/* ⚠️ RACINE DE LANGUE ET TEXTES, LUS UNE SEULE FOIS AU DEMARRAGE. (2026-08-01)

   Depuis la publication du francais, le site vit sur deux prefixes : l'anglais
   a la racine, le francais sous « /fr ». Un chemin ecrit en dur dans ce fichier
   renvoyait donc toujours vers la version ANGLAISE, et un `fetch` de fiche
   produit rapportait une carte en anglais au milieu d'une page francaise.
   Shopify expose la racine courante : on part de la, jamais d'un « / » suppose.

   Les textes, eux, viennent de snippets/isli-textes.liquid, donc des fichiers
   de langue. Une chaine ecrite ici ne serait traduisible par aucun moyen.
   Les valeurs de repli restent en anglais : elles ne servent que si le bloc
   JSON manque, ce qui ne doit pas arriver. */
var ISLI_RACINE = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
var ISLI_TEXTES = (function () {
  try {
    return JSON.parse(document.getElementById('isli-textes').textContent);
  } catch (e) {
    return {};
  }
})();
if (ISLI_TEXTES.racine) ISLI_RACINE = ISLI_TEXTES.racine;

function isliChemin(suffixe) {
  return ISLI_RACINE.replace(/\/$/, '') + suffixe;
}

/*
  ISLI STUDIO — surcouche JS du header.
    a) lien Contact dans la colonne droite, à la manière du "Contactez-nous" de LV
    b) symbole de devise accolé au code ISO du sélecteur de pays ("EUR €")

  Aucune table de symboles : le thème rend déjà, pour CHAQUE pays du panneau,
  un span.localization-form__currency contenant "<code ISO> <symbole>". Seul
  l'attribut hidden est conditionnel, le texte est toujours dans la page, et le
  pays courant porte aria-current="true". On lit donc la vérité du serveur.

  Pourquoi un observer : le morphing du thème ne saute que les attributs du
  noeud marqué data-skip-node-update, il descend dans ses enfants. Tout noeud
  injecté est donc effacé à chaque re-rendu du header, notamment à chaque
  changement de panier. Un seul observer sert les deux injections.
*/
(function () {
  var CONTACT_LABEL = 'Contact';
  var CONTACT_HREF = isliChemin('/pages/contact');

  function injectContact(header) {
    if (header.querySelector('.isli-contact')) return;

    var actions =
      header.querySelector('.header__column--right') ||
      header.querySelector('[class*="header__actions"]');
    if (!actions) return;

    var link = document.createElement('a');
    link.className = 'isli-contact';
    link.href = CONTACT_HREF;
    link.textContent = CONTACT_LABEL;
    actions.insertBefore(link, actions.firstChild);
  }

  /* Code ISO du pays courant. Depuis la refonte du tiroir (2026-08-01), la
     verite du serveur vit sur la racine du gabarit, data-isli-loc-courant :
     un attribut STATIQUE, que les clics dans la liste ne touchent pas. Lire
     la ligne aria-selected serait faux des qu'un pays est clique puis
     abandonne sans « Continuer ». */
  function currentCountry(header) {
    var src = document.querySelector('[data-isli-loc-courant]');
    if (!src) return null;

    var code = (src.getAttribute('data-isli-loc-courant') || '').trim().toUpperCase();
    return /^[A-Z]{2}$/.test(code) ? code : null;
  }

  /* Le selecteur s'ecrit "FR / EUR" : code pays, barre oblique, code devise.
     Le theme ne rend que le code devise ; on prefixe sans toucher a son noeud
     de texte, pour que le morphing puisse le remplacer sans rien casser.
     La barre oblique est du VRAI texte et non un ::after : en pseudo-element
     elle sort du contenu accessible et un lecteur d'ecran annoncerait "FREUR". */
  function decorateCurrency(header) {
    var nodes = header.querySelectorAll('.currency-code');
    if (!nodes.length) return;

    var country = currentCountry(header);
    if (!country) return;

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var existing = el.querySelector('.isli-country');

      if (existing) {
        // le pays a pu changer sans que le noeud soit recree
        if (existing.textContent !== country + ' / ') existing.textContent = country + ' / ';
        continue;
      }

      var span = document.createElement('span');
      span.className = 'isli-country';
      span.textContent = country + ' / ';
      el.insertBefore(span, el.firstChild);
    }
  }

  function run() {
    var header = document.querySelector('#header-component');
    if (!header) return;
    injectContact(header);
    decorateCurrency(header);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);

  var host = document.querySelector('#header-group') || document.body;
  if (window.MutationObserver && host && !host.__isliUnderlineWatched) {
    host.__isliUnderlineWatched = true;
    new MutationObserver(run).observe(host, { childList: true, subtree: true });
  }
})();
/*
  ISLI STUDIO — rails produits de l'accueil (« Shoulder Bags » et « Earrings »).

  Deux réglages sur chaque rail :

  1) Défilement libre. Le composant slideshow d'Horizon capte le glisser-souris
     (assets/slideshow.js #handleMouseDown) et, au relâchement, recentre la
     piste sur une carte avec inertie et rappel de snap, d'où une sensation
     d'accrochage. On le désactive (attribut disabled="true", relu à chaque
     geste) et on installe un glisser 1:1 sans inertie. La désactivation impose
     overflow: hidden côté thème ; isli-lv.css restaure overflow-x: scroll pour
     que la molette et le trackpad défilent nativement.

  2) Pas de changement d'image pendant le défilement. Chaque carte révèle sa 2e
     image sur on:pointerenter (survol). Or au trackpad le curseur reste fixe et
     ce sont les cartes qui défilent SOUS lui : chacune déclenche alors son
     survol, ce qui fait « clignoter » les 2es images pendant qu'on fait défiler.
     Tant qu'un défilement est en cours, on coupe les événements pointeur des
     galeries (classe .isli-scrolling -> pointer-events: none, posée en CSS) et
     on remet toute carte en cours d'aperçu sur sa 1re image. Le survol délibéré,
     lui, refonctionne dès l'arrêt du défilement.
*/
(function () {
  /* ⚠️ CETTE LISTE DOIT SUIVRE CELLE DE assets/isli-lv.css, chapitre PISTE.

     Le rail des recommandations de la fiche produit (« You may also like ») a
     été aligné sur le dessin des rangées d'accueil côté CSS, mais cette
     constante était restée à deux portées. Conséquence exacte : la règle
     `slideshow-component[disabled='true'] slideshow-slides { overflow-x: scroll }`
     ne s'appliquait pas, faute de l'attribut que ce module est seul à poser ; la
     piste restait en overflow: hidden avec 2410px de contenu dans 1280px, sans
     flèches, donc rigoureusement immobile. Le glisser-souris et le geste
     trackpad n'étaient pas installés non plus. */
  var SECTION =
    ":is([id$='__product_list_fa6P9H'], [id$='__product_list_earrings'], [id$='__product_recommendations_qggXJq'])";
  var THRESHOLD = 6; // px au-delà desquels on considère que c'est un glisser
  var IDLE = 160; // ms d'inactivité avant de rendre le survol aux cartes

  /* ⚠️ L'ATTRIBUT disabled DOIT ÊTRE TENU, PAS SEULEMENT POSÉ.

     assets/slideshow.js ligne 563 écrit `this.disabled = this.isNested ||
     this.disabled` APRÈS un `await viewTransition.current`. Sur une section
     injectée par la Section Rendering API, cet écrit atterrit plusieurs images
     après le nôtre et RETIRE l'attribut : le thème rend alors son
     overflow: hidden à la piste et le défilement remeurt en silence. Constaté
     en direct sur la fiche produit après un re-rendu des recommandations.

     Une réaffirmation sur la frame suivante ne suffit pas, le délai n'étant pas
     borné. On observe donc l'attribut et on le repose. Pas de boucle : la garde
     de valeur fait que reposer 'true' ne redéclenche rien d'utile. */
  function lockDisabled(comp) {
    if (comp.__isliDisabledLock) return;
    comp.__isliDisabledLock = true;

    new MutationObserver(function () {
      if (comp.getAttribute('disabled') !== 'true') comp.setAttribute('disabled', 'true');
    }).observe(comp, { attributes: true, attributeFilter: ['disabled'] });
  }

  function setup(section) {
    var scroller = section.querySelector('slideshow-slides');
    if (!scroller) return;

    /* ⚠️ GARDE SUR UNE PROPRIÉTÉ JS, PAS SUR UN ATTRIBUT.

       C'était `scroller.dataset.isliDrag`. Or morph réconcilie les attributs du
       nœud avec le HTML du serveur, où cet attribut n'existe pas : il le
       SUPPRIME en gardant le même nœud et ses écouteurs. La garde tombait donc
       après chaque re-rendu, setup() repassait sur un nœud déjà équipé et
       rattachait un second écouteur de molette : le rail défilait deux fois
       plus vite, puis trois, à chaque re-rendu.

       Une propriété JS n'est pas un attribut : morph ne la voit pas et ne la
       touche pas. Et si morph remplace vraiment le nœud, la propriété est
       absente sur le nouveau, donc setup() repasse, ce qui est voulu. */
    if (scroller.__isliDrag) return;
    scroller.__isliDrag = true;

    // coupe le glisser natif du thème sur ce rail
    var comp = scroller.closest('slideshow-component');
    if (comp) {
      comp.setAttribute('disabled', 'true');
      lockDisabled(comp);
    }

    /* --- suppression du survol pendant le défilement --- */
    var scrolling = false;
    var idleTimer;

    function resetGalleries() {
      var gals = section.querySelectorAll('.card-gallery');
      for (var i = 0; i < gals.length; i++) {
        // remet la carte en cours d'aperçu sur sa 1re image
        gals[i].dispatchEvent(new PointerEvent('pointerleave', { bubbles: false }));
      }
    }

    scroller.addEventListener(
      'scroll',
      function () {
        if (!scrolling) {
          scrolling = true;
          section.classList.add('isli-scrolling');
          resetGalleries();
        }
        clearTimeout(idleTimer);
        idleTimer = setTimeout(function () {
          scrolling = false;
          section.classList.remove('isli-scrolling');
        }, IDLE);
      },
      { passive: true }
    );

    /* --- glisser-souris 1:1 --- */
    var down = false;
    var startX = 0;
    var startLeft = 0;
    var moved = 0;

    scroller.addEventListener(
      'pointerdown',
      function (e) {
        if (e.button !== 0) return;
        down = true;
        moved = 0;
        startX = e.clientX;
        startLeft = scroller.scrollLeft;
        scroller.style.cursor = 'grabbing';
        scroller.style.scrollBehavior = 'auto';
      },
      true
    );

    scroller.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      moved = Math.max(moved, Math.abs(dx));
      if (moved > THRESHOLD && scroller.hasPointerCapture && !scroller.hasPointerCapture(e.pointerId)) {
        scroller.setPointerCapture(e.pointerId);
      }
      scroller.scrollLeft = startLeft - dx;
    });

    function end() {
      if (!down) return;
      down = false;
      scroller.style.cursor = '';
      // un glisser franc ne doit pas ouvrir la carte survolée au relâchement
      if (moved > THRESHOLD) {
        var block = function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
        };
        scroller.addEventListener('click', block, { capture: true, once: true });
        setTimeout(function () {
          scroller.removeEventListener('click', block, { capture: true });
        }, 0);
      }
    }

    scroller.addEventListener('pointerup', end);
    scroller.addEventListener('pointercancel', end);

    /* --- defilement trackpad deux doigts (molette horizontale) ---
       Les galeries de carte sont en overflow-x: hidden (pour bloquer le glisser
       DANS les images) : or un conteneur overflow: hidden dont le contenu deborde
       reste une boite de defilement qui CAPTE la molette horizontale sans la
       propager au rail. Resultat : deux doigts vers la droite au-dessus d'une
       carte ne faisait plus rien. On reprend la main : sur une intention
       horizontale (|deltaX| > |deltaY|), on pilote nous-memes le rail et on coupe
       le comportement natif (defilement pige de la carte + navigation arriere du
       geste). L'intention verticale est laissee a la page. */
    scroller.addEventListener(
      'wheel',
      function (e) {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
        e.preventDefault();
        // behavior instant : le scroller porte scroll-behavior: smooth, or une
        // molette doit avancer au pixel pres sans animation, comme un scroll natif.
        scroller.scrollBy({ left: e.deltaX, behavior: 'instant' });
      },
      { passive: false }
    );

    scroller.style.cursor = 'grab';
  }

  function run() {
    var sections = document.querySelectorAll(SECTION);
    for (var i = 0; i < sections.length; i++) setup(sections[i]);
  }

  /* ⚠️ LE RAIL DES RECOMMANDATIONS N'EXISTE PAS AU CHARGEMENT.

     <product-recommendations> attend que la section entre dans le champ, va
     chercher /recommendations/products et injecte le résultat par morphSection
     (assets/product-recommendations.js). Ce chemin ne déclenche AUCUN
     événement : ni shopify:section:load, ni rien d'autre. Un run() au
     chargement ne trouve donc qu'un conteneur vide, et tout ce qui précède
     resterait lettre morte sur cette section précise. */
  function watchRecommendations(host) {
    if (host.__isliWatched) return;
    host.__isliWatched = true;

    /* ⚠️ PAS DE disconnect() APRÈS LE PREMIER SUCCÈS. Le composant recharge ses
       recommandations à chaque changement d'attribut (product-recommendations.js
       lignes 23 à 45) et l'éditeur de thème re-morphe la section sans émettre
       d'événement : un observateur débranché laisserait la piste re-injectée
       sans équipement, et le défilement remourrait en silence.
       Le coût est un querySelector par salve, et setup() ressort aussitôt grâce
       à sa garde. Aucune boucle possible : on n'observe que
       childList, et setup() n'écrit que des attributs. */
    var queued = false;

    function later() {
      if (queued) return;
      queued = true;

      /* ⚠️ setTimeout ET NON requestAnimationFrame. Un onglet masqué SUSPEND
         requestAnimationFrame : la piste ne serait équipée qu'au retour de
         l'utilisateur sur l'onglet, et une page ouverte en arrière-plan
         arriverait sans défilement. Les minuteurs, eux, tournent toujours,
         seulement bridés. Constaté en test : avec rAF, rien ne s'armait. */
      setTimeout(function () {
        queued = false;
        if (host.querySelector('slideshow-slides')) run();
      }, 0);
    }

    new MutationObserver(function () {
      /* Tout de suite, pour le cas courant. */
      if (host.querySelector('slideshow-slides')) run();
      /* Et une fois la tâche en cours finie, pour le cas où morph remplace
         encore la piste après nous. La garde de setup() rend le second
         passage gratuit quand il n'y a rien de neuf. */
      later();
    }).observe(host, { childList: true, subtree: true });
  }

  function watch() {
    var hosts = document.querySelectorAll('product-recommendations');
    for (var i = 0; i < hosts.length; i++) watchRecommendations(hosts[i]);
  }

  /* run() ET watch() au même moment : une section dupliquée dans l'éditeur de
     thème arrive par shopify:section:load avec son <product-recommendations>
     encore vide, il faut donc aussi l'observer, pas seulement l'équiper. */
  function start() {
    run();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();

/*
  ISLI STUDIO — page produit : tiroirs de réassurance et rangée d'accordéons.

  Tout est délégué sur document : le thème re-rend la fiche produit par morph
  (changement de variante, retour de panier), un écouteur posé sur un noeud de
  la section serait perdu au premier re-rendu.

  Les tiroirs sont des <dialog> natifs : pile d'affichage, piège de focus,
  touche Échap et inertie de l'arrière-plan sont donnés par le navigateur. On
  n'ajoute que l'ouverture, la fermeture par la croix et le clic sur le fond.
*/
(function () {
  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  /* --------------------------------------------------------- TIROIRS */

  function showDrawer(dialog) {
    if (!dialog || typeof dialog.showModal !== 'function') return;
    /* Annule une sortie en cours : re-cliquer la ligne pendant la fermeture
       doit rouvrir, pas laisser le tiroir finir de partir. */
    dialog.classList.remove('is-closing');
    if (!dialog.open) dialog.showModal();
  }

  function openDrawer(id) {
    showDrawer(document.getElementById(id));
  }

  /* ⚠️ FERMETURE ANIMÉE : on joue la sortie, PUIS on appelle close().

     Même principe que assets/dialog.js du thème. Appeler close() d'emblée
     sortait le dialogue de la pile d'affichage dès la première image : le fond
     flou disparaissait net et, surtout, le panneau perdait le `position: fixed`
     que la feuille du navigateur ne donne qu'à `dialog:modal`. Il retombait sur
     sa position statique, au milieu de la colonne produit, et glissait vers la
     droite depuis là. C'est la « section qui se coupe en deux » vue sur mobile.

     Le CSS ne peut pas s'en charger seul : la propriété `overlay`, qui aurait
     retenu le dialogue dans la pile, est propre à Chromium et WebKit ne
     l'honore pas. C'est donc le script qui tient la fenêtre de sortie, et ça
     marche partout. */
  var DRAWER_OUT_MS = 450;

  function closeDrawer(dialog) {
    if (!dialog || !dialog.open) return;
    if (dialog.classList.contains('is-closing')) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduce) {
      dialog.close();
      return;
    }

    dialog.classList.add('is-closing');

    var done = false;

    function finish() {
      if (done) return;
      done = true;
      dialog.removeEventListener('transitionend', onEnd);
      /* showDrawer a retiré la classe : le tiroir a été rouvert pendant sa
         sortie, ce minuteur ne doit surtout pas le refermer. */
      if (!dialog.classList.contains('is-closing')) return;
      dialog.classList.remove('is-closing');
      if (dialog.open) dialog.close();
    }

    /* transitionend du panneau remonte jusqu'au dialogue. On filtre sur la
       propriété ET sur la cible : le corps du tiroir a ses propres transitions
       et un événement venu d'ailleurs ne doit pas fermer avant l'heure. */
    function onEnd(event) {
      if (event.propertyName !== 'transform') return;
      if (!event.target || !event.target.classList) return;
      if (!event.target.classList.contains('isli-drawer__panel')) return;
      finish();
    }

    dialog.addEventListener('transitionend', onEnd);

    /* Filet : si la transition ne démarre jamais (onglet en arrière-plan, nœud
       remplacé par un morph du thème), on ferme quand même. */
    setTimeout(finish, DRAWER_OUT_MS + 150);
  }

  /* Exposée : le module du cadeau de sac ferme son tiroir après un choix, et
     doit passer par la MÊME sortie animée que la croix, sinon le panneau
     disparaît d'un coup et perd son ancrage plein écran. */
  window.isliCloseDrawer = closeDrawer;

  /* ------------------------------------------------------- PANNEAUX */

  /* Un seul panneau ouvert à la fois : sur ordinateur ils se superposent tous
     au même endroit, deux panneaux ouverts se recouvriraient. */
  function setPanel(panel, open) {
    if (!panel) return;

    /* ⚠️ `inert` va sur le CONTENU, jamais sur le panneau lui-même.

       Sur ordinateur les panneaux fermés restent dans le flux, superposés sous
       le panneau ouvert, avec seulement `pointer-events: none` : leur croix de
       fermeture et leurs liens resteraient atteignables à la tabulation sans
       `inert`, et l'utilisateur au clavier traverserait trois panneaux
       invisibles avant de sortir de la fiche.

       Mais l'attribut a longtemps été posé sur la <section> entière, laquelle
       contient le bouton d'ouverture du format mobile : `inert` s'appliquant à
       toute la descendance, ce bouton naissait inerte et les trois accordéons
       ne s'ouvraient pas au téléphone. Voir le commentaire de
       snippets/isli-panel.liquid. Le conteneur porte donc [data-isli-panel-inner]
       et le bouton reste dehors.

       Pas de repli sur le panneau si le marqueur manque : ce serait exactement
       remettre le défaut. On préfère perdre la protection clavier, invisible,
       qu'un accordéon qui ne s'ouvre plus, visible de tous. */
    var content = panel.querySelector('[data-isli-panel-inner]');

    if (open) {
      panel.setAttribute('data-open', '');

      if (content) {
        content.removeAttribute('inert');

        /* ⚠️ ON MESURE .isli-panels__scroll ET NON content.

           Sur mobile la course d'ouverture est une max-height, et une borne
           fixe de 1200px faisait que l'animation était finie bien avant la fin
           de sa durée. On pose donc la hauteur réelle.

           Mesurer `content` donnerait un chiffre faux : tant que la boîte est
           écrasée à 0, son scrollHeight ne compte que le débordement visible
           d'un côté, soit la moitié du contenu. C'est l'enfant qui porte la
           hauteur naturelle. */
        var scroll = content.querySelector('.isli-panels__scroll');
        content.style.setProperty('--isli-panel-h', (scroll ? scroll.scrollHeight : content.scrollHeight) + 'px');

        /* ⚠️ SUR ORDINATEUR, LA HAUTEUR N'EST PAS CELLE DU CONTENU MAIS CELLE
           DE LA PLACE DISPONIBLE.

           Le panneau est ancré en bas de la colonne et grandit vers le haut,
           par-dessus la fiche. Sa hauteur ouverte était écrite en dur,
           `100svh - header - 120px`, une valeur juste le jour où elle a été
           posée : depuis, la colonne a changé et il manquait 36px, soit
           exactement la ligne du titre et du prix, qui restait à découvert en
           haut. Un nombre magique de plus dériverait de nouveau.

           On mesure donc la vraie distance : du bord BAS du panneau, qui est
           son point d'ancrage et reste juste même quand il est fermé et de
           hauteur nulle, jusqu'au haut de la colonne. */
        var colonne = closest(panel, '.product-details');

        if (colonne && window.matchMedia('(min-width: 1024px)').matches) {
          var place = Math.round(panel.getBoundingClientRect().bottom - colonne.getBoundingClientRect().top);
          if (place > 0) content.style.setProperty('--isli-panel-space', place + 'px');
        }
      }
    } else {
      panel.removeAttribute('data-open');
      if (content) content.setAttribute('inert', '');
    }

    var toggles = document.querySelectorAll('[data-isli-panel-toggle="' + panel.id + '"]');
    for (var i = 0; i < toggles.length; i++) {
      toggles[i].setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  /* La hauteur du texte change avec la largeur : un panneau resté ouvert pendant
     une rotation d'écran garderait la mesure de l'ancienne largeur, et se
     retrouverait tronqué ou trop grand. On repose la mesure, sans animation
     puisqu'aucune transition n'est en cours. */
  var reMesure;
  window.addEventListener('resize', function () {
    clearTimeout(reMesure);
    reMesure = setTimeout(function () {
      var ouverts = document.querySelectorAll('[data-isli-panel][data-open] [data-isli-panel-inner]');
      for (var i = 0; i < ouverts.length; i++) {
        var scroll = ouverts[i].querySelector('.isli-panels__scroll');
        if (scroll) ouverts[i].style.setProperty('--isli-panel-h', scroll.scrollHeight + 'px');

        var panneau = closest(ouverts[i], '[data-isli-panel]');
        var colonne = closest(ouverts[i], '.product-details');
        if (panneau && colonne && window.matchMedia('(min-width: 1024px)').matches) {
          /* Le panneau est ouvert, donc sa boîte occupe déjà la place : on
             mesure le bas du GROUPE, qui est le point d'ancrage, et non le bas
             du panneau, qui a bougé avec l'ouverture. */
          var groupe = closest(panneau, '.isli-panels__group');
          var ancre = groupe ? groupe.getBoundingClientRect().bottom - 32 : panneau.getBoundingClientRect().bottom;
          var place = Math.round(ancre - colonne.getBoundingClientRect().top);
          if (place > 0) ouverts[i].style.setProperty('--isli-panel-space', place + 'px');
        }
      }
    }, 150);
  });

  function closeSiblings(group, keep) {
    var panels = group.querySelectorAll('[data-isli-panel]');
    for (var i = 0; i < panels.length; i++) {
      if (panels[i] !== keep) setPanel(panels[i], false);
    }
  }

  function togglePanel(id) {
    var panel = document.getElementById(id);
    if (!panel) return;

    var group = closest(panel, '.isli-panels');
    var willOpen = !panel.hasAttribute('data-open');

    if (group) closeSiblings(group, panel);
    setPanel(panel, willOpen);
  }

  /* ----------------------------------------------------------- LIENS */

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var opener = closest(target, '[data-isli-drawer-open]');
    if (opener) {
      event.preventDefault();

      /* ⚠️ On ouvre le tiroir VOISIN avant de chercher par identifiant.

         Les lignes de réassurance de la fiche produit portent toutes le même
         identifiant : les paramètres passés à un snippet ne survivent à aucun
         filtre côté Liquid, et plusieurs tentatives de correctif dans le thème
         n'ont pas tenu. Conséquence sans ce garde-fou : les trois lignes
         ouvraient le premier tiroir, et « 14-day returns » affichait le texte
         de la livraison.

         Le tiroir d'une ligne est son frère immédiat dans le même conteneur.
         Le viser par la structure plutôt que par un identifiant est exact quel
         que soit l'état des identifiants, et le repli par identifiant continue
         de servir partout ailleurs. */
      var row = closest(opener, '.isli-usp__row');
      var sibling = row ? row.querySelector('dialog.isli-drawer') : null;

      if (sibling) {
        showDrawer(sibling);
        return;
      }

      openDrawer(opener.getAttribute('data-isli-drawer-open'));
      return;
    }

    var closer = closest(target, '[data-isli-drawer-close]');
    if (closer) {
      event.preventDefault();
      var dialog = closest(closer, 'dialog');
      if (dialog) closeDrawer(dialog);
      return;
    }

    /* Clic sur le fond : la cible est le <dialog> lui-même, le panneau étant
       un enfant qui capte ses propres clics. */
    if (target.tagName === 'DIALOG' && target.classList.contains('isli-drawer')) {
      closeDrawer(target);
      return;
    }

    var panelCloser = closest(target, '[data-isli-panel-close]');
    if (panelCloser) {
      event.preventDefault();
      setPanel(document.getElementById(panelCloser.getAttribute('data-isli-panel-close')), false);
      return;
    }

    var panelToggle = closest(target, '[data-isli-panel-toggle]');
    if (panelToggle) {
      event.preventDefault();
      togglePanel(panelToggle.getAttribute('data-isli-panel-toggle'));
    }
  });

  /* Échap et le geste de retour ferment le dialogue NATIVEMENT, donc sans
     animation, et on retombe sur l'artefact que closeDrawer existe pour éviter.
     On intercepte l'annulation pour repasser par lui. L'événement `cancel` ne
     remonte pas : écoute en phase de capture. */
  document.addEventListener(
    'cancel',
    function (event) {
      var dialog = event.target;
      if (!dialog || !dialog.classList) return;
      if (!dialog.classList.contains('isli-drawer')) return;
      event.preventDefault();
      closeDrawer(dialog);
    },
    true
  );

  /* Échap ferme le panneau ouvert. Les <dialog> se ferment déjà seuls, et un
     panneau ouvert n'est pas modal : il faut donc le traiter à la main. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var open = document.querySelector('[data-isli-panel][data-open]');
    if (!open) return;

    setPanel(open, false);

    var toggle = document.querySelector('[data-isli-panel-toggle="' + open.id + '"]');
    if (toggle) toggle.focus();
  });
})();

/*
  ISLI STUDIO — roue du libellé sur les boutons rendus par le thème.

  Le thème rend le libellé en simple noeud de texte dans le bouton
  (snippets/add-to-cart-button.liquid). Un noeud de texte ne se transforme pas :
  pour le faire rouler comme les boutons de bannière, il lui faut une piste et
  un double. On enveloppe donc, sans toucher au snippet du thème.

  Le contrat de markup est celui attendu par .isli-atc dans isli-lv.css :
  le double d'abord, hors flux, en attente sous la boîte ; l'exemplaire réel
  ensuite, dans le flux, c'est lui qui donne sa hauteur à la piste. aria-hidden
  ne porte que sur le double, le nom accessible du bouton reste le libellé,
  énoncé une seule fois.

  TROIS BOUTONS passent par ici, tous rendus par le thème et donc hors de notre
  markup : l'ajout au panier de la fiche, le « Continue shopping » de la 404 et
  le bouton de caisse de la page panier. Ce dernier porte son libellé dans un
  <span class="button-text"> plutôt qu'en noeud direct : la fonction descend
  d'un cran quand ce span existe, le reste est identique.

  L'observateur est nécessaire : le thème re-rend la fiche et le panier par
  morph à chaque changement de variante ou de quantité, ce qui efface notre
  enveloppe. On observe la zone concernée quand elle existe, jamais le document
  entier.
*/
(function () {
  /* Un descripteur par bouton. `label` remplace le libellé du thème, `lock`
     pose le cadenas devant. Les deux ne servent aujourd'hui qu'au bouton de
     caisse : le thème dit « Check out », ISLI dit « Secure checkout » avec le
     cadenas, comme le tiroir de Wirney dont ce dessin est repris. Réécrire le
     libellé ici plutôt que dans snippets/cart-summary.liquid nous évite de
     modifier un deuxième fichier coeur du thème, celui-ci étant partagé avec la
     page panier. */
  var TARGETS = [
    { selector: '.product-details .add-to-cart-button' },
    { selector: "main[data-template='404'] a.button" },
    {
      selector: '.cart-page .cart__checkout-button, cart-drawer-component .cart__checkout-button',
      /* ⚠️ LU DANS LES FICHIERS DE LANGUE (2026-08-01). Ce libellé remplace
         celui du thème APRÈS le rendu : le HTML servi disait bien « Payer » en
         français, et ce script le réécrivait aussitôt en anglais. Aucune sonde
         sur le HTML ne pouvait le voir, seul un regard sur la page rendue.
         Repli anglais volontaire : il ne sert que si le bloc JSON manque. */
      label: (ISLI_TEXTES.paiement_securise || 'Secure checkout'),
      lock: true,
    },
    /* Le bouton de caisse du composeur de set. Il porte DÉJÀ sa piste, écrite
       en Liquid : on ne vient ici que poser le cadenas, pour que les deux
       boutons qui mènent au paiement portent la même réassurance, dessinée une
       seule fois. C'est ce qui justifie que le cadenas soit posé avant la
       sortie anticipée de `wrap`. */
    { selector: '[data-isli-pack-checkout]', lock: true },
  ];

  var LOCK =
    '<svg class="isli-atc__lock" width="11" height="13" viewBox="0 0 12 14" fill="none" aria-hidden="true">' +
    '<rect x="1" y="6" width="10" height="7" fill="currentColor"/>' +
    '<path d="M3 6V4a3 3 0 0 1 6 0v2" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>';

  /* Zones re-rendues par morph. Une zone absente est simplement ignorée. */
  var WATCHED = ['.product-details', '.cart-page', 'cart-drawer-component'];

  function wrap(button, config) {
    /* Le bouton de caisse enveloppe déjà son libellé : c'est ce span qui
       devient l'hôte de la piste, sinon on envelopperait un élément et non du
       texte, et la piste n'aurait pas de hauteur. */
    var host = button.querySelector('.button-text') || button;

    /* ⚠️ LE CADENAS SE POSE AVANT LA SORTIE ANTICIPÉE, ET C'EST VOULU.
       Il ne roule pas, il reste : une icône qui tourne avec le mot ferait un
       manège, pas une réassurance. Il vit donc HORS de la piste, et il n'a
       aucune raison de dépendre d'elle. C'est ce qui permet de le poser sur le
       bouton du composeur, qui porte sa piste écrite en Liquid et sortirait
       d'ici avant d'avoir reçu quoi que ce soit. */
    if (config.lock && !host.querySelector('.isli-atc__lock')) {
      host.insertAdjacentHTML('afterbegin', LOCK);
    }

    if (button.querySelector('.isli-atc')) return;

    /* le libellé est le seul noeud de texte direct de l'hôte : l'icône et la
       pastille de confirmation sont des éléments */
    var textNodes = [];
    var label = '';

    for (var i = 0; i < host.childNodes.length; i++) {
      var node = host.childNodes[i];
      if (node.nodeType === 3 && node.textContent.trim() !== '') {
        textNodes.push(node);
        label += node.textContent.trim();
      }
    }

    if (!label) return;
    if (config.label) label = config.label;

    var track = document.createElement('span');
    track.className = 'isli-atc';

    var ghost = document.createElement('span');
    ghost.className = 'isli-atc__face isli-atc__face--ghost';
    ghost.setAttribute('aria-hidden', 'true');
    ghost.textContent = label;

    var real = document.createElement('span');
    real.className = 'isli-atc__face';
    real.textContent = label;

    track.appendChild(ghost);
    track.appendChild(real);

    host.replaceChild(track, textNodes[0]);
    for (var j = 1; j < textNodes.length; j++) {
      textNodes[j].parentNode.removeChild(textNodes[j]);
    }

  }

  function run() {
    for (var i = 0; i < TARGETS.length; i++) {
      var buttons = document.querySelectorAll(TARGETS[i].selector);
      for (var j = 0; j < buttons.length; j++) wrap(buttons[j], TARGETS[i]);
    }
  }

  function watch() {
    for (var i = 0; i < WATCHED.length; i++) {
      var zone = document.querySelector(WATCHED[i]);
      if (!zone) continue;

      /* ⚠️ Un seul observateur par zone. `start` est rappelé à chaque
         shopify:section:load, donc sans ce drapeau un observateur de plus se
         greffait sur le même noeud à chaque re-rendu de section, et aucun
         n'était jamais déconnecté : la page finissait par exécuter `run` des
         dizaines de fois par mutation. Le drapeau est porté par le noeud
         lui-même, il disparaît donc avec lui. */
      if (zone.__isliWatched) continue;
      zone.__isliWatched = true;

      /* les mutations de l'observateur sont les nôtres au premier tour : wrap
         sort tout de suite si la piste est déjà là, donc pas de boucle */
      new MutationObserver(run).observe(zone, { childList: true, subtree: true });
    }
  }

  function start() {
    run();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();

/*
  ISLI STUDIO — LISTE D'ENVIES.

  Elle vit dans le NAVIGATEUR, pas sur le serveur. Shopify n'autorise l'écriture
  dans la fiche client qu'à une application disposant de l'accès approuvé aux
  données client protégées : hors de portée d'un thème, et hors de proportion
  pour ce site. Conséquence assumée : la liste est attachée à l'appareil, elle
  ne suit pas d'un téléphone à un ordinateur et disparaît si le visiteur vide
  son navigateur.

  Format de stockage, volontairement simple et documenté pour qu'une reprise
  ultérieure vers un compte se fasse par un envoi unique :

    localStorage['isli:wishlist'] = [{ "handle": "moonlight", "at": 1750000000 }]

  Le plus récent en tête. Les pièces supprimées ou dépubliées sont retirées
  d'elles-mêmes au premier affichage de la page, la carte ne répondant plus.

  Trois surfaces, un seul état :
    le bouton de la fiche produit    [data-isli-wish]
    le compteur du header            [data-isli-wish-count]
    la page                          [data-isli-wishlist]
*/
(function () {
  var KEY = 'isli:wishlist';
  var PAGE = isliChemin('/pages/wishlist');
  var CARD_SECTION = 'isli-wishlist-card';

  /* ------------------------------------------------------------ STOCKAGE */

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var list = JSON.parse(raw);
      if (!Array.isArray(list)) return [];
      return list.filter(function (item) {
        return item && typeof item.handle === 'string' && item.handle;
      });
    } catch (e) {
      /* mode privé, quota plein, JSON abîmé : une liste vide vaut mieux qu'une
         page cassée */
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* rien à faire : le visiteur garde sa session en cours, sans persistance */
    }
    sync();
  }

  function has(handle) {
    var list = read();
    for (var i = 0; i < list.length; i++) {
      if (list[i].handle === handle) return true;
    }
    return false;
  }

  function toggle(handle) {
    var list = read();
    var kept = [];
    var found = false;

    for (var i = 0; i < list.length; i++) {
      if (list[i].handle === handle) {
        found = true;
      } else {
        kept.push(list[i]);
      }
    }

    if (!found) kept.unshift({ handle: handle, at: Date.now() });
    write(kept);
    return !found;
  }

  function drop(handles) {
    var list = read();
    var kept = [];

    for (var i = 0; i < list.length; i++) {
      if (handles.indexOf(list[i].handle) === -1) kept.push(list[i]);
    }

    if (kept.length !== list.length) write(kept);
  }

  /* --------------------------------------------------------- SURFACES */

  function syncButtons() {
    var buttons = document.querySelectorAll('[data-isli-wish]');
    for (var i = 0; i < buttons.length; i++) {
      var handle = buttons[i].getAttribute('data-isli-wish');
      buttons[i].setAttribute('aria-pressed', has(handle) ? 'true' : 'false');
    }
  }

  function syncCount() {
    var total = read().length;
    var nodes = document.querySelectorAll('[data-isli-wish-count]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = total;

      /* on masque comme le thème masque la sienne : la pastille entière passe
         en visually-hidden, et l'icône perd son masque de découpe */
      var bubble = nodes[i].closest('.cart-bubble');
      if (bubble) bubble.classList.toggle('visually-hidden', total === 0);

      var icon = nodes[i].closest('.isli-wish-link__icon');
      if (icon) icon.classList.toggle('isli-wish-link__icon--has-items', total > 0);
    }

    /* le nom accessible porte le compte : la pastille est décorative, et un
       lien annoncé « Liste d'envies » ne dirait pas qu'elle contient trois
       pièces */
    var links = document.querySelectorAll('.isli-wish-link');
    for (var j = 0; j < links.length; j++) {
      links[j].setAttribute(
        'aria-label',
        total === 0 ? (ISLI_TEXTES.liste_envies || 'Wishlist') : (ISLI_TEXTES.liste_envies || 'Wishlist') + ', ' + total + (total > 1 ? (ISLI_TEXTES.piece_plusieurs || ' pieces') : (ISLI_TEXTES.piece_une || ' piece'))
      );
    }
  }

  function sync() {
    syncButtons();
    syncCount();
    renderPage();
  }

  /* -------------------------------------------------- ICÔNE DU HEADER */

  function injectIcon(header) {
    var actions = header.querySelector('header-actions');
    if (!actions || actions.querySelector('.isli-wish-link')) return;

    var link = document.createElement('a');
    link.className = 'isli-wish-link header-actions__action';
    link.href = PAGE;
    link.setAttribute('aria-label', 'Wishlist');
    /* Le balisage recopie celui du panier, à la classe près : même boîte, même
       enveloppe d'icône, même pastille .cart-bubble avec son fond en calque
       séparé. Tout ce que le thème sait faire sur la pastille du panier, la
       taille, les couleurs, leur bascule en header transparent, l'animation
       d'ajout, s'applique donc ici sans être réécrit.
       snippets/cart-bubble.liquid et snippets/header-actions.liquid font foi. */
    link.innerHTML =
      '<span class="isli-wish-link__icon">' +
      '<span class="svg-wrapper" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none" focusable="false">' +
      '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78Z" ' +
      'stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />' +
      '</svg></span>' +
      '<div class="cart-bubble visually-hidden" data-maintain-ratio>' +
      '<span class="cart-bubble__background"></span>' +
      '<span class="cart-bubble__text">' +
      '<span class="cart-bubble__text-count" data-isli-wish-count aria-hidden="true">0</span>' +
      '</span></div>' +
      '</span>';

    /* devant le bouton de compte : la liste d'envies précède le compte */
    actions.insertBefore(link, actions.firstChild);
    syncCount();
  }

  function watchHeader() {
    var header = document.querySelector('#header-component') || document.querySelector('.header');
    if (!header) return;

    injectIcon(header);

    /* le morphing du thème redessine le header à chaque changement de panier :
       toute injection est effacée, on la repose. Un seul observateur, cf. le
       même garde-fou sur la roue du libellé. */
    if (header.__isliWatched) return;
    header.__isliWatched = true;

    new MutationObserver(function () {
      injectIcon(header);
    }).observe(header, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------------- PAGE */

  var rendering = false;

  function renderPage() {
    var root = document.querySelector('[data-isli-wishlist]');
    if (!root || rendering) return;

    var grid = root.querySelector('[data-isli-wishlist-grid]');
    var empty = root.querySelector('[data-isli-wishlist-empty]');
    var summary = root.querySelector('[data-isli-wishlist-summary]');
    var list = read();

    if (!list.length) {
      grid.innerHTML = '';
      grid.hidden = true;
      empty.hidden = false;
      summary.hidden = true;
      return;
    }

    empty.hidden = true;
    summary.hidden = false;
    summary.textContent = list.length + (list.length > 1 ? (ISLI_TEXTES.piece_plusieurs || ' pieces') : (ISLI_TEXTES.piece_une || ' piece'));

    rendering = true;

    /* une requête par pièce, toutes en parallèle, l'ordre de la liste étant
       rendu par l'ordre du tableau et non par l'ordre des réponses */
    var requests = list.map(function (item) {
      return fetch(isliChemin('/products/') + encodeURIComponent(item.handle) + '?section_id=' + CARD_SECTION)
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .catch(function () {
          return '';
        });
    });

    Promise.all(requests).then(function (parts) {
      var missing = [];
      var html = '';

      for (var i = 0; i < parts.length; i++) {
        if (parts[i]) {
          html += parts[i];
        } else {
          missing.push(list[i].handle);
        }
      }

      grid.innerHTML = html;
      grid.hidden = false;
      rendering = false;

      /* pièce supprimée ou dépubliée : on la retire au lieu de laisser un trou.
         Le nettoyage relance un rendu, qui cette fois ne trouve plus de
         manquante : la boucle s'arrête d'elle-même. */
      if (missing.length) drop(missing);
    });
  }

  /* ------------------------------------------------------------ LIENS */

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var toggler = target.closest('[data-isli-wish]');
    if (toggler) {
      event.preventDefault();
      toggle(toggler.getAttribute('data-isli-wish'));
      return;
    }

    var remover = target.closest('[data-isli-wish-remove]');
    if (remover) {
      event.preventDefault();
      drop([remover.getAttribute('data-isli-wish-remove')]);
    }
  });

  /* un autre onglet a modifié la liste : les surfaces suivent */
  window.addEventListener('storage', function (event) {
    if (event.key === KEY) sync();
  });

  function start() {
    watchHeader();
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();

/*
  ISLI STUDIO — composeur de set (sections/isli-pack-builder.liquid).

  La sélection vit en mémoire de page, volontairement : un set est une intention
  du moment, pas une liste à conserver comme les envies. Recharger repart d'une
  page blanche, ce qui évite de retrouver un set fantôme trois jours plus tard.

  Les sommes sont calculées en CENTIMES, jamais sur des chaînes affichées. Le
  format monétaire vient du thème, passé en attribut par la section, et il n'est
  appliqué qu'au moment d'écrire à l'écran.

  Le passage en caisse ajoute tout le set au panier en UNE requête, puis part au
  paiement. Avec un palier atteint, on passe par /discount/<code>, la seule voie
  sans application pour appliquer un code et enchaîner sur la caisse.
*/
(function () {
  var root;
  var selection = {}; // id de variante -> quantité
  var moneyFormat = '';

  /* ------------------------------------------------------------- MONNAIE */

  /* Réimplémentation du filtre money, limitée aux quatre gabarits de Shopify.
     On ne s'en sert QUE pour des sommes calculées : chaque prix de pièce est
     déjà formaté par le serveur. */
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0];
    var decimals = parts[1];

    function group(separator) {
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    }

    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, name) {
      switch (name) {
        case 'amount_no_decimals':
          return group(',');
        case 'amount_with_comma_separator':
          return group('.') + ',' + decimals;
        case 'amount_no_decimals_with_comma_separator':
          return group('.');
        case 'amount_with_apostrophe_separator':
          return group("'") + '.' + decimals;
        default:
          return group(',') + '.' + decimals;
      }
    });
  }

  /* ------------------------------------------------------------- LECTURE */

  function cards() {
    return root.querySelectorAll('[data-isli-pack-item]');
  }

  function cardOf(id) {
    return root.querySelector('[data-isli-pack-item="' + id + '"]');
  }

  function totals() {
    var count = 0;
    var cents = 0;

    for (var id in selection) {
      var card = cardOf(id);
      if (!card) continue;
      count += selection[id];
      cents += selection[id] * parseInt(card.getAttribute('data-price'), 10);
    }

    return { count: count, cents: cents };
  }

  /* État de l'offre « on en achète N, la suivante est offerte ».

     LE CALCUL REPRODUIT CELUI DE SHOPIFY, ce n'est pas une estimation. Une
     remise Buy X Get Y offre les pièces LES MOINS CHÈRES du groupe : on étale
     donc la sélection en une entrée par unité, on trie par prix croissant, et
     on offre les `groupes × offer_free` premières. Toutes les boucles ne sont
     pas au même prix (49, 72, 76 et 80 € au catalogue) : offrir la plus chère
     afficherait un montant que le checkout démentirait. */
  function offerState() {
    var buy = parseInt(root.getAttribute('data-offer-buy'), 10) || 0;
    var free = parseInt(root.getAttribute('data-offer-free'), 10) || 0;
    var group = buy + free;

    var units = [];
    for (var id in selection) {
      var card = cardOf(id);
      if (!card) continue;
      var price = parseInt(card.getAttribute('data-price'), 10);
      for (var i = 0; i < selection[id]; i++) units.push(price);
    }

    units.sort(function (a, b) {
      return a - b;
    });

    var count = units.length;
    var on = buy > 0 && free > 0;
    var groups = on ? Math.floor(count / group) : 0;
    var freeUnits = groups * free;
    var saved = 0;

    for (var j = 0; j < freeUnits; j++) saved += units[j];

    var remainder = on ? count % group : 0;
    /* Ce qu'il reste à ajouter pour la PROCHAINE pièce offerte : le groupe
       entier quand on vient d'en boucler un, le reste sinon. */
    var missing = on ? group - remainder : 0;

    return {
      on: on,
      count: count,
      buy: buy,
      group: group,
      groups: groups,
      freeUnits: freeUnits,
      saved: saved,
      missing: missing,
      remainder: remainder
    };
  }

  /* -------------------------------------------------------------- RENDU */

  /* ⚠️ LE LIBELLÉ DES PIÈCES NON CHOISIES CHANGE QUAND LA SUIVANTE EST OFFERTE.
     Une fois deux pièces au set, la troisième ne coûte rien : les cartes qui
     portent encore un bouton d'ajout annoncent donc « Add for free ». Sans
     cela, le client lit la même invitation qu'au premier ajout et ne fait pas
     le lien entre le message du panneau et le geste qui reste à faire.

     La condition est `remainder >= buy` et non `remainder === 2` : elle suit
     les réglages de l'offre, elle ne les recopie pas. Si la remise passait un
     jour à « 3 achetées, 2 offertes », les deux derniers paliers annonceraient
     la gratuité tout seuls.

     Le libellé est réécrit sur LES DEUX FACES de la roue. N'en changer qu'une
     ferait apparaître l'ancien mot au survol, sur ordinateur. */
  function renderCards() {
    var list = cards();
    var state = offerState();
    var prochainOffert = state.on && state.remainder >= state.buy;
    var libelle = prochainOffert
      ? root.getAttribute('data-add-free-label') || 'Add for free'
      : root.getAttribute('data-add-label') || '';

    for (var i = 0; i < list.length; i++) {
      var card = list[i];
      var id = card.getAttribute('data-isli-pack-item');
      var quantity = selection[id] || 0;
      var bouton = card.querySelector('[data-isli-pack-add]');

      card.classList.toggle('isli-pack-card--picked', quantity > 0);
      bouton.hidden = quantity > 0;
      card.querySelector('.isli-pack-card__stepper').hidden = quantity === 0;
      card.querySelector('[data-isli-pack-quantity]').textContent = quantity;

      if (libelle) {
        var faces = bouton.querySelectorAll('.isli-atc__face');
        for (var f = 0; f < faces.length; f++) {
          if (faces[f].textContent !== libelle) faces[f].textContent = libelle;
        }
        bouton.classList.toggle('isli-pack-card__add--free', prochainOffert);
      }

      /* ⚠️ LE PRIX SUIT EXACTEMENT LE BOUTON, PAS L'OFFRE.
         Le bouton annonce « Add for free » sur les pièces pas encore retenues :
         la pastille et le prix barré sortent sur LES MÊMES cartes, jamais sur
         une pièce déjà au set. Le prix d'une pièce retenue est un prix dû, la
         barrer annoncerait une gratuité que la caisse ne fera pas. */
      var offert = prochainOffert && quantity === 0;
      var pastille = card.querySelector('[data-isli-pack-free]');

      card.classList.toggle('isli-pack-card--free', offert);
      if (pastille) pastille.hidden = !offert;
    }

    /* L'état est aussi porté par la section entière : la grille a besoin de le
       savoir pour réserver la place de la pastille sur téléphone, où la ligne
       titre + prix n'a pas de marge. */
    root.classList.toggle('isli-pack--free', prochainOffert);
  }

  function renderPanel() {
    var sums = totals();
    var list = root.querySelector('[data-isli-pack-list]');
    var empty = root.querySelector('[data-isli-pack-empty]');
    var html = '';

    for (var id in selection) {
      var card = cardOf(id);
      if (!card) continue;

      var image = card.getAttribute('data-image');
      html +=
        '<li class="isli-pack__line" data-isli-pack-line="' + id + '">' +
        (image ? '<img class="isli-pack__line-image" src="' + image + '" alt="" loading="lazy">' : '<span class="isli-pack__line-image"></span>') +
        '<span class="isli-pack__line-body">' +
        '<span class="isli-pack__line-title">' + card.getAttribute('data-title') + '</span>' +
        '<span class="isli-pack__line-meta">' + selection[id] + ' × ' + card.getAttribute('data-price-formatted') + '</span>' +
        '</span>' +
        '<button type="button" class="isli-pack__line-remove" data-isli-pack-remove="' + id + '" aria-label="Remove">' +
        '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">' +
        '<path d="M1 1l8 8M9 1l-8 8" stroke="currentColor" /></svg></button>' +
        '</li>';
    }

    list.innerHTML = html;
    empty.hidden = sums.count > 0;

    root.querySelector('[data-isli-pack-count]').textContent = sums.count;

    var subtotals = root.querySelectorAll('[data-isli-pack-subtotal]');
    for (var s = 0; s < subtotals.length; s++) {
      subtotals[s].textContent = formatMoney(sums.cents);
    }

    /* ⚠️ LA BARRE REPLIÉE DU TÉLÉPHONE MONTRE LE MONTANT DÛ, PAS LE SOUS-TOTAL.
       Elle n'affiche qu'un seul chiffre : ce doit donc être celui que la caisse
       demandera, remise déduite. Elle annonçait 228 € pour trois pièces à 76 €
       quand le client en paie 152, la troisième étant offerte : le chiffre le
       plus visible du composeur était le seul à ignorer l'offre.

       Même calcul que la ligne de total du panneau et que le paiement
       fractionné, pour qu'aucun des trois ne puisse dériver. */
    var dus = root.querySelectorAll('[data-isli-pack-due]');
    if (dus.length) {
      var du = sums.cents - offerState().saved;
      for (var d = 0; d < dus.length; d++) dus[d].textContent = formatMoney(du);
    }

    var checkout = root.querySelector('[data-isli-pack-checkout]');
    checkout.disabled = sums.count === 0;

    renderTiers(sums);
    renderInstalment(sums);
  }

  /* Paiement fractionné, calculé sur le total réellement dû : le sous-total
     moins la remise du palier atteint. Annoncer une mensualité sur le prix
     plein serait faux dès la deuxième pièce. */
  function renderInstalment(sums) {
    var line = root.querySelector('[data-isli-pack-instalment]');
    if (!line) return;

    var template = root.getAttribute('data-instalment-label') || '';
    var count = parseInt(root.getAttribute('data-instalment-count'), 10) || 4;

    if (!template || sums.count === 0 || sums.cents === 0) {
      line.hidden = true;
      return;
    }

    var due = sums.cents - offerState().saved;

    line.textContent = template.replace('[price]', formatMoney(Math.round(due / count)));
    line.hidden = false;
  }

  function renderTiers(sums) {
    var box = root.querySelector('[data-isli-pack-tiers]');
    var savingRow = root.querySelector('[data-isli-pack-saving-row]');
    var totalRow = root.querySelector('[data-isli-pack-total-row]');
    var state = offerState();

    /* Remise annoncée = remise appliquée. La remise automatique porte sur cette
       collection et toutes les pièces du composeur en viennent : le montant
       affiché est celui du checkout, pas une estimation. */
    if (savingRow && totalRow) {
      var applies = state.freeUnits > 0 && sums.cents > 0;
      savingRow.hidden = !applies;
      totalRow.hidden = !applies;

      if (applies) {
        /* ⚠️ UN LIBELLÉ, PAS UNE PHRASE. Cette ligne reprenait le message de
           l'offre, qui est une invitation et non un intitulé de total. Résultat
           mesuré : « Free piece unlocked · Add any one you like, it is on us »
           passait sur deux lignes dans le <dt>, écrasait le <dd> voisin, et le
           « − » restait sur la première ligne pendant que le montant tombait à
           la seconde. Le client lisait un moins tout seul, puis un prix qui
           n'avait plus l'air d'être retiré. */
        root.querySelector('[data-isli-pack-saving-label]').textContent =
          state.freeUnits > 1
            ? state.freeUnits + ' ' + (ISLI_TEXTES.piece_offerte_plusieurs || 'pieces free')
            : ISLI_TEXTES.piece_offerte_une || 'Free piece';
        root.querySelector('[data-isli-pack-saving]').textContent = '−' + formatMoney(state.saved);
        root.querySelector('[data-isli-pack-total]').textContent = formatMoney(sums.cents - state.saved);
      }
    }

    if (!box) return;

    var message = root.querySelector('[data-isli-pack-tier-message]');
    var fill = root.querySelector('[data-isli-pack-gauge-fill]');

    if (!state.on) {
      message.textContent = '';
      return;
    }

    /* ⚠️ LA JAUGE MESURE LE CHEMIN VERS LE DÉBLOCAGE, PAS LE GROUPE ENTIER.
       Elle courait sur les TROIS pièces du groupe : une pièce remplissait un
       tiers, deux pièces les deux tiers, et la barre n'était pleine qu'une fois
       la troisième ajoutée. Le client lisait donc « ajoutez-en encore une »
       alors qu'il avait DÉJÀ gagné son cadeau : c'est en atteignant DEUX pièces
       qu'il le débloque, la troisième étant ce qu'on lui donne.

       Elle court maintenant sur `buy`, soit deux paliers : une pièce la remplit
       à moitié, deux la remplissent entièrement et annoncent le cadeau.

       ⚠️ ELLE NE REDESCEND JAMAIS, ET ELLE COMPTE EN ABSOLU.
       Elle a d'abord été écrite sur le reste du cycle : elle repartait donc de
       zéro à la troisième pièce, comme s'il fallait en ajouter trois de plus.
       Or presque personne ne compose au-delà de trois pièces : ce que la barre
       doit dire à ce moment, c'est que le set est fait. Elle mesure donc le
       nombre total de pièces vers le déblocage, et reste pleine ensuite. */
    var vers = state.buy;
    var ratio = state.count >= vers ? 1 : state.count / vers;
    fill.style.width = Math.round(ratio * 100) + '%';

    var ticks = root.querySelectorAll('[data-isli-pack-tick]');
    for (var i = 0; i < ticks.length; i++) {
      ticks[i].classList.toggle('isli-pack__tick--reached', state.freeUnits > 0);
    }

    var unlocked = root.getAttribute('data-offer-unlocked') || '';

    /* ⚠️ [count] ET [s]. Le nombre manquant vaut 1 ou 2 selon le palier : une
       phrase qui nomme la pièce doit donc s'accorder, sans quoi on lit
       « 2 more piece ». Le jeton [s] rend 's' au pluriel et rien au singulier.
       Les deux jetons sont documentés dans le libellé du réglage. */
    function poser(modele, nombre) {
      return String(modele || '')
        .split('[count]')
        .join(nombre)
        .split('[s]')
        .join(nombre > 1 ? 's' : '');
    }

    var claimed = root.getAttribute('data-offer-claimed') || unlocked;

    /* ⚠️ TROIS ÉTATS, ET « DÉBLOQUÉ » N'EST PLUS LE MÊME QUE « OBTENU ».
       1. remainder === vers : le client vient d'atteindre deux pièces. Il a
          gagné son cadeau mais ne l'a pas encore choisi. C'est le moment de la
          félicitation, et de lui dire qu'il prend la pièce qu'il veut.
       2. remainder === 0 avec des pièces offertes : la pièce gratuite est dans
          le set, l'offre est consommée. On le constate, et on compte vers la
          suivante, l'offre jouant jusqu'à cinq fois par commande.
       3. le reste : il manque `vers - remainder` pièces pour débloquer.
       Le manque se compte vers le DÉBLOCAGE et non vers la fin du groupe,
       sinon la phrase demanderait une pièce de plus que nécessaire. */
    if (state.freeUnits > 0) {
      /* Une pièce au moins est offerte : le set tient debout, il n'y a plus
         rien à débloquer. On le dit et on laisse le bouton faire le reste.
         ⚠️ On ne compte PAS vers la pièce offerte suivante : l'offre joue
         jusqu'à cinq fois, mais annoncer un nouveau palier ici renverrait le
         client à la grille au moment précis où il a fini. Le réglage
         `offer_next` n'est donc plus employé. */
      message.textContent = claimed;
    } else if (state.count >= vers) {
      message.textContent = unlocked;
    } else {
      message.textContent = poser(root.getAttribute('data-offer-progress'), vers - state.count);
    }
  }

  function render() {
    renderCards();
    renderPanel();
  }

  /* ------------------------------------------------------------ FILTRES */

  function applyFilter(tag) {
    var list = cards();
    var visible = 0;

    for (var i = 0; i < list.length; i++) {
      var tags = list[i].getAttribute('data-tags') || '';
      var match = !tag || tags.split(',').indexOf(tag) > -1;
      list[i].hidden = !match;
      if (match) visible++;
    }

    var buttons = root.querySelectorAll('[data-isli-pack-filter]');
    for (var j = 0; j < buttons.length; j++) {
      buttons[j].setAttribute('aria-pressed', buttons[j].getAttribute('data-isli-pack-filter') === tag ? 'true' : 'false');
    }

    root.querySelector('[data-isli-pack-no-match]').hidden = visible > 0;
  }

  /* ------------------------------------------------------------- CAISSE */

  function checkout(button) {
    var items = [];
    for (var id in selection) {
      items.push({ id: parseInt(id, 10), quantity: selection[id] });
    }
    if (!items.length) return;

    /* le libellé est en deux exemplaires, la roue en ayant besoin : on écrit
       dans les deux, sans quoi le double garderait l'ancien texte */
    var faces = root.querySelectorAll('[data-isli-pack-checkout-label] .isli-atc__face');
    var previous = faces.length ? faces[0].textContent : '';

    function setLabel(text) {
      for (var f = 0; f < faces.length; f++) faces[f].textContent = text;
    }

    button.disabled = true;
    setLabel(ISLI_TEXTES.un_instant || 'One moment…');

    fetch(isliChemin('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart');

        /* Plus de détour par /discount/<code> : la remise est AUTOMATIQUE côté
           Shopify depuis le 2026-07-24. On va droit en caisse, où elle se pose
           seule. C'est aussi ce qui la rend valable pour un client arrivé au
           panier sans passer par cette page.
           ⚠️ Par isliChemin : « /checkout » nu sortait un client français du
           préfixe /fr, la caisse s'ouvrait en anglais (mesuré le 2026-08-01). */
        window.location.href = isliChemin('/checkout');
      })
      .catch(function () {
        button.disabled = false;
        setLabel(previous);
      });
  }

  /* -------------------------------------------------------------- LIENS */

  function onClick(event) {
    var target = event.target;
    if (!target || !target.closest || !root || !root.contains(target)) return;

    var filter = target.closest('[data-isli-pack-filter]');
    if (filter) {
      applyFilter(filter.getAttribute('data-isli-pack-filter'));
      return;
    }

    var remove = target.closest('[data-isli-pack-remove]');
    if (remove) {
      delete selection[remove.getAttribute('data-isli-pack-remove')];
      render();
      return;
    }

    var toggle = target.closest('[data-isli-pack-panel-toggle]');
    if (toggle) {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      root.querySelector('[data-isli-pack-panel]').classList.toggle('isli-pack__panel--open', !open);
      return;
    }

    if (target.closest('[data-isli-pack-checkout]')) {
      checkout(target.closest('[data-isli-pack-checkout]'));
      return;
    }

    var card = target.closest('[data-isli-pack-item]');
    if (!card) return;

    var id = card.getAttribute('data-isli-pack-item');
    var quantity = selection[id] || 0;

    if (target.closest('[data-isli-pack-add]') || target.closest('[data-isli-pack-increase]')) {
      selection[id] = quantity + 1;
      render();
      return;
    }

    if (target.closest('[data-isli-pack-decrease]')) {
      if (quantity <= 1) {
        delete selection[id];
      } else {
        selection[id] = quantity - 1;
      }
      render();
    }
  }

  /* ⚠️ LA PIÈCE VENUE DE LA FICHE PRODUIT.
     Le bouton « Choose my earrings » d'une fiche de boucles emporte l'identifiant
     de sa variante dans `?piece=`. On la pose dans le set avant le premier rendu,
     pour que le panneau, la jauge et la carte soient justes du premier coup.

     Trois précautions, chacune pour une raison précise :

     1. L'IDENTIFIANT EST VÉRIFIÉ AVANT DE SERVIR DE SÉLECTEUR. `cardOf` le colle
        dans `[data-isli-pack-item="…"]` : une valeur trafiquée y casserait la
        requête. Seuls des chiffres passent.
     2. UNE PIÈCE INTROUVABLE EST IGNORÉE EN SILENCE. Épuisée depuis, retirée de
        la collection, lien recopié à la main : le composeur s'ouvre normalement,
        simplement vide. Une alerte n'apprendrait rien d'utile au visiteur.
     3. L'ADRESSE EST NETTOYÉE, TOUJOURS, MÊME QUAND RIEN N'A ÉTÉ AJOUTÉ. La
        sélection ne vit qu'en mémoire de page : sans ce nettoyage, un
        rechargement ou un retour arrière remettrait la pièce que le visiteur
        vient peut-être de retirer. */
  function preselection() {
    var params = new URLSearchParams(window.location.search);
    var piece = params.get('piece');
    if (!piece) return;

    if (/^\d+$/.test(piece) && cardOf(piece)) selection[piece] = 1;

    params.delete('piece');
    var query = params.toString();
    window.history.replaceState(
      window.history.state,
      '',
      window.location.pathname + (query ? '?' + query : '') + window.location.hash
    );
  }

  function start() {
    root = document.querySelector('[data-isli-pack]');
    if (!root) return;

    moneyFormat = root.getAttribute('data-money-format') || '{{amount}}';
    selection = {};
    preselection();
    render();
  }

  document.addEventListener('click', onClick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();

/*
  ISLI STUDIO — bouton « + » des recommandations du tiroir panier.

  Ajoute la pièce au panier puis fait rafraîchir le tiroir PAR LE THÈME, sans
  rechargement ni fermeture. Deux points méritent d'être expliqués.

  1. La délégation est posée sur `document`, une seule fois, et pas dans le
     snippet du rail : le tiroir est re-rendu par morph à chaque changement de
     panier, et un morph n'exécute pas les scripts qu'il réécrit. Un écouteur
     posé dans la zone morphée serait perdu au premier ajout.

  2. Le rafraîchissement passe par l'événement `shopify:cart:lines-update` du
     thème, auquel `component-cart-items.js` et `cart-icon.js` sont abonnés. Ces
     deux modules ne lisent pas `detail` : ils attendent une propriété `promise`
     sur l'événement, qui résout vers la charge utile. On demande donc à
     /cart/add.js de nous renvoyer la section du tiroir déjà rendue
     (paramètre `sections`) et on la leur passe : le thème morphe lui-même, avec
     ses propres transitions, et la pastille du header se met à jour seule.
     Sans cette propriété, l'événement partirait et rien ne se passerait.
*/
(function () {
  var SECTION = 'cart-drawer-section';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function announce(payload) {
    var event = new CustomEvent('shopify:cart:lines-update', { bubbles: true });

    /* `cart-icon.js` lit `cart.totalQuantity` ou `detail.itemCount`, on fournit
       les deux plutôt que de parier sur l'un. */
    event.promise = Promise.resolve({
      cart: { totalQuantity: payload.item_count },
      detail: {
        itemCount: payload.item_count,
        sections: payload.sections || {},
      },
    });

    document.dispatchEvent(event);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-isli-reco-add]');
    if (!button) return;

    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;

    var id = parseInt(button.getAttribute('data-isli-reco-add'), 10);
    if (!id) return;

    button.setAttribute('aria-busy', 'true');

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: SECTION }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return fetch(root() + 'cart.js?sections=' + SECTION, { headers: { Accept: 'application/json' } });
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        announce(cart);
      })
      .catch(function () {
        /* Le panier n'a pas bougé : le bouton redevient cliquable et rien ne
           ment à l'écran. Une pièce peut avoir été épuisée entre le rendu du
           rail et le clic. */
      })
      .then(function () {
        button.removeAttribute('aria-busy');
      });
  });
})();


/*
  ISLI STUDIO — fermeture du tiroir panier au clic hors du panneau.

  Au-dessus de 990px le thème ouvre le tiroir en NON MODAL (`panel.show()`,
  assets/theme-drawer.js ligne 222). Il n'y a donc aucun `::backdrop`, et le
  seul écouteur de fermeture au clic extérieur du thème est posé sur le panneau
  lui-même (`panel.addEventListener('click', this.#onBackdropClick)`, ligne
  234) : un clic dans la page ne l'atteint jamais. Le thème l'assume, son
  commentaire dit « in sidebar mode the dialog has no backdrop so this handler
  is inert », parce qu'il suppose que le tiroir RÉTRÉCIT la page au lieu de la
  recouvrir. La CSS ISLI a supprimé ce rétrécissement
  (`.page-wrapper--drawer-open { margin-right: 0 }`) : le tiroir se pose
  par-dessus, et plus rien ne le ferme au clic.

  En dessous de 990px le panneau est modal, le clic sur le fond a pour cible le
  <dialog> et le thème ferme déjà seul. On ne double pas son travail : on sort
  si le panneau est `:modal`. Le test porte sur l'état RÉEL du dialogue et non
  sur une largeur recopiée, il reste donc juste si le thème déplace un jour son
  seuil de 990px.

  Trois précautions, chacune corrige un défaut constaté :

  1. `pointerdown` et non `click`. Le bouton du header ouvre le tiroir sur
     `click` : à l'instant du `pointerdown` le tiroir est encore fermé, la garde
     [open] échoue, et le clic qui ouvre ne peut donc pas refermer dans la
     foulée. `pointerdown` couvre aussi le tactile sans écouteur séparé. En
     phase de capture, pour survivre à un stopPropagation en amont.

  2. On sort si la cible est le déclencheur du header. Sans cela, un clic sur
     l'icône panier tiroir ouvert fermerait ici au `pointerdown` puis `toggle`
     rouvrirait au `click` : le tiroir deviendrait infermable par son propre
     bouton.

  3. On sort si la cible est dans un autre <dialog>. Ce qui est posé PAR-DESSUS
     n'est pas « en dehors ». Même précaution que #hasOpenNestedDialog() côté
     thème.

  On appelle `close()` du composant, jamais `dialog.close()` : c'est lui qui
  retire le piège de focus, joue le glissement de sortie, rend le défilement et
  met sessionStorage à jour.
*/
(function () {
  document.addEventListener(
    'pointerdown',
    function (event) {
      var drawer = document.querySelector('theme-drawer#cart-drawer[open]');
      if (!drawer || typeof drawer.close !== 'function') return;

      var panel = drawer.querySelector('dialog');
      if (!panel || !panel.open) return;

      /* Panneau modal : le fond existe, le thème s'en charge déjà. */
      if (panel.matches(':modal')) return;

      var target = event.target;
      if (!(target instanceof Element)) return;
      if (panel.contains(target)) return;
      if (target.closest('[aria-controls="cart-drawer"]')) return;
      if (target.closest('dialog')) return;

      /* Le composant rend le focus au déclencheur À LA FIN de son animation de
         sortie. Si le clic visait un champ de saisie, l'utilisateur commence à
         taper et se fait reprendre le focus 300ms plus tard : on le lui rend. */
      var field = target.closest('input, textarea, select, [contenteditable="true"]');

      Promise.resolve(drawer.close()).then(function () {
        if (field && document.contains(field)) field.focus();
      });
    },
    true
  );
})();


/*
  ISLI STUDIO — le tiroir panier se ferme quand on le quitte par un lien.

  ⚠️ CE N'EST PAS LE LIEN QUI EST BLOQUÉ, C'EST LA PAGE QUI RESTE À L'ÉCRAN.
  layout/theme.liquid ligne 25 active les transitions de vue INTER-DOCUMENTS
  (`@view-transition { navigation: auto }`) et pose juste après un
  `<link rel="expect" href="#MainContent" blocking="render">`. Le navigateur
  garde donc l'ancienne page affichée, tiroir ouvert compris, pendant TOUT le
  chargement de la suivante, puis fond l'une dans l'autre. Sur un clic vers
  /pages/build-your-set le tiroir restait ainsi ouvert une bonne seconde, et
  cela ressemblait à un lien mort.

  On ferme donc à l'instant du clic. Le glissement de sortie joue pendant que
  la page charge, ce qui remplit exactement le temps d'attente au lieu de le
  laisser vide. La navigation, elle, n'est jamais empêchée : aucun
  preventDefault ici.

  Trois abstentions, chacune volontaire :
  - clic modifié (ctrl, cmd, majuscule, molette) : la page courante ne bouge
    pas, le tiroir non plus ;
  - `target="_blank"` et `download` : même raison ;
  - ancre pure (#) et pseudo-protocoles : rien ne se charge.

  Le tiroir PLEIN est concerné autant que le vide : le titre d'une ligne de
  panier est un lien vers la fiche produit. Et la règle vaut pour TOUS les
  tiroirs, pas seulement le panier : un lien qui emmène ailleurs doit refermer
  ce qu'il quitte.

  ⚠️ ON REMONTE DEPUIS LE LIEN, ON NE CHERCHE PAS `theme-drawer[open]`.
  L'attribut `open` posé sur l'hôte (assets/theme-drawer.js ligne 230) est un
  MIROIR de l'état, et il se désynchronise : quand `open()` est appelé sur un
  tiroir que le composant croit déjà ouvert, il passe par `#bringToFront()`,
  qui ne repose pas l'attribut. Constaté en direct, panneau ouvert et attribut
  absent, le module ne faisait alors rien. On lit donc l'état RÉEL, celui du
  <dialog>, et on remonte depuis le lien cliqué : c'est aussi ce qui rend le
  module valable pour n'importe quel tiroir sans en nommer aucun.
*/
(function () {
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var target = event.target;
    if (!target || !target.closest) return;

    var lien = target.closest('a[href]');
    if (!lien) return;

    if (lien.target && lien.target !== '_self') return;
    if (lien.hasAttribute('download')) return;

    /* `href` brut et non la propriété résolue : une ancre pure s'y lit telle
       quelle, alors que `lien.href` renverrait l'URL complète de la page. */
    var href = lien.getAttribute('href') || '';
    if (href === '' || href.charAt(0) === '#') return;
    if (/^(javascript|mailto|tel):/i.test(href)) return;

    var panneau = lien.closest('dialog');
    if (!panneau || !panneau.open) return;

    /* Tiroir du thème : on passe par le composant, lui seul retire le piège de
       focus, joue le glissement de sortie et rend le défilement. */
    var drawer = lien.closest('theme-drawer');
    if (drawer && typeof drawer.close === 'function') {
      drawer.close();
      return;
    }

    /* Tiroir maison : même sortie animée, exposée pour l'occasion. */
    if (typeof window.isliCloseDrawer === 'function') window.isliCloseDrawer(panneau);
  });
})();


/*
  ISLI STUDIO — les trois écrans muets du panier.

  Recensés le 2026-07-25. Ce ne sont pas des écarts de dessin, ce sont des trous :
  trois situations où le panier ne répond rien, et où deux fois sur trois l'écran
  affiche quelque chose de FAUX.

  1. ÉCHEC RÉSEAU SUR UN CHANGEMENT DE QUANTITÉ.
     assets/component-cart-items.js ligne 288, la branche `.catch` : elle fait un
     console.error et émet un CartErrorEvent, puis s'arrête là. La remise du
     champ à sa valeur précédente n'existe QUE dans #handleCartError (ligne 317),
     appelé uniquement quand le serveur répond une erreur métier. Sur une requête
     perdue, le champ garde donc la valeur tapée et le total ne bouge pas : le
     client lit une quantité que le serveur n'a jamais acceptée.

  2. ÉCHEC RÉSEAU SUR UN CODE PROMOTION.
     assets/cart-discount.js lignes 135 et 209, mêmes branches muettes. Le
     créneau d'erreur existe pourtant déjà dans la page, avec ses deux <small>
     prêts à l'emploi, et le code vient même de les remasquer.

  3. ARTICLE DEVENU INDISPONIBLE, LIGNE TOUJOURS AU PANIER.
     snippets/quantity-selector.liquid ligne 81 désactive le CHAMP quand
     variant.available est faux, mais laisse les boutons plus et moins actifs, et
     aucun texte ne dit pourquoi. Le client voit un champ mort sans explication
     et deux boutons qui ne font rien.

  Rien de tout cela ne touche un fichier cœur : on écoute l'événement standard
  `shopify:cart:error`, qui remonte jusqu'à document (bubbles: true dans
  standard-events.js), et on observe le panier après chaque re-rendu.
*/
(function () {
  var TEXTES = {
    reseau: 'Your cart could not be updated. Check your connection and try again.',
    indisponible: 'This piece is no longer available. Remove it to continue.'
  };

  /* Le bandeau vit en tête de la liste d'articles, tiroir comme page panier. Un
     seul à l'écran : un deuxième message remplace le premier plutôt que de
     s'empiler. */
  function poser(texte) {
    /* Ordre voulu : le tiroir d'abord s'il est ouvert, sinon la colonne d'articles
       de la page panier. `.cart-page__items` et non `cart-items-component` :
       ce dernier est en pleine largeur et le bandeau se retrouvait collé au bord
       de la fenêtre, à l'écart du bloc auquel il se rapporte. */
    var hotes = document.querySelectorAll('.cart-drawer__items, .cart-page__items');
    if (!hotes.length) return;

    var hote = hotes[0];
    var avis = hote.querySelector(':scope > .isli-cart-notice');

    if (!avis) {
      avis = document.createElement('p');
      avis.className = 'isli-cart-notice';
      avis.setAttribute('role', 'status');
      hote.insertBefore(avis, hote.firstChild);
    }

    avis.textContent = texte;

    clearTimeout(avis.__isliTimer);
    avis.__isliTimer = setTimeout(function () {
      if (avis.parentNode) avis.parentNode.removeChild(avis);
    }, 8000);
  }

  /* Une requête perdue veut dire que RIEN n'a changé côté serveur : toute
     quantité qui ne vaut plus sa valeur d'origine est un mensonge à l'écran. On
     les repose toutes, ce qui est exact quelle que soit la ligne fautive, alors
     que l'événement, lui, ne dit pas laquelle. */
  function reposerLesQuantites() {
    var champs = document.querySelectorAll('.cart-drawer__items input[type="number"], .cart-page input[type="number"]');
    for (var i = 0; i < champs.length; i++) {
      if (champs[i].defaultValue && champs[i].value !== champs[i].defaultValue) {
        champs[i].value = champs[i].defaultValue;
      }
    }
  }

  document.addEventListener('shopify:cart:error', function (event) {
    /* SERVICE_UNAVAILABLE est le code que le thème donne à ses branches .catch,
       c'est à dire aux requêtes perdues. Les erreurs métier, elles, portent leur
       propre message et le thème les affiche déjà dans la ligne concernée : on
       ne double pas son travail. */
    if (event.code !== 'SERVICE_UNAVAILABLE') return;

    reposerLesQuantites();
    poser(TEXTES.reseau);
  });

  /* Article indisponible. Le marqueur est le CHAMP désactivé alors que le bouton
     plus ne l'est pas : quand c'est une règle de quantité qui verrouille la
     ligne, le thème désactive les trois d'un coup. Les deux boutons sont coupés
     au passage, ils ne faisaient rien d'autre que promettre une action
     impossible. */
  function marquerIndisponibles(racine) {
    /* Une seule classe, celle des vraies lignes d'article
       (snippets/cart-products.liquid lignes 110 et 148). Viser `tr, li` en plus
       ferait remonter toutes les listes du tiroir, y compris le rail de
       recommandations, à chaque salve de mutations. */
    var lignes = racine.querySelectorAll('.cart-items__table-row');

    for (var i = 0; i < lignes.length; i++) {
      var ligne = lignes[i];
      var champ = ligne.querySelector('input[type="number"]');
      var plus = ligne.querySelector('button[name="plus"]');
      if (!champ || !plus) continue;
      if (!champ.disabled || plus.disabled) continue;
      if (ligne.querySelector('.isli-cart-notice')) continue;

      plus.disabled = true;
      var moins = ligne.querySelector('button[name="minus"]');
      if (moins) moins.disabled = true;

      var cellule = ligne.querySelector('.cart-items__error');
      var cible = cellule || ligne;
      var avis = document.createElement('p');
      avis.className = 'isli-cart-notice';
      avis.setAttribute('role', 'status');
      avis.textContent = TEXTES.indisponible;
      cible.appendChild(avis);
      if (cellule) cellule.classList.remove('hidden');
    }
  }

  function zones() {
    return document.querySelectorAll('theme-drawer#cart-drawer, .cart-page');
  }

  function balayer() {
    var z = zones();
    for (var i = 0; i < z.length; i++) marquerIndisponibles(z[i]);
  }

  /* ⚠️ ON N'OBSERVE PAS document.body.

     Le panier est re-rendu par morph et ce chemin n'émet aucun événement, il
     faut donc observer. Mais un observateur posé sur tout le corps de page se
     réveille à CHAQUE mutation du site, y compris l'injection du rail de
     recommandations et les re-rendus du header, pour ne jamais rien trouver
     ailleurs que dans le panier. On se limite aux deux conteneurs qui, eux,
     survivent au morph : <theme-drawer id="cart-drawer"> et .cart-page. */
  function observer() {
    var z = zones();

    for (var i = 0; i < z.length; i++) {
      if (z[i].__isliCartWatched) continue;
      z[i].__isliCartWatched = true;

      (function (hote) {
        var enAttente = false;

        new MutationObserver(function () {
          if (enAttente) return;
          enAttente = true;
          setTimeout(function () {
            enAttente = false;
            marquerIndisponibles(hote);
          }, 0);
        }).observe(hote, { childList: true, subtree: true });
      })(z[i]);
    }
  }

  function demarrer() {
    balayer();
    observer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  /* La page panier est re-rendue en entier après une suppression : le conteneur
     .cart-page peut être remplacé, et son observateur partir avec. */
  document.addEventListener('shopify:section:load', demarrer);
})();

/*
  ISLI STUDIO — le cadeau des fiches de sac (blocks/isli-bag-gift.liquid).

  L'encart montre une pièce pré-choisie ; la ligne du bas ouvre le tiroir des
  autres pièces. Le choix est tenu dans un champ caché de l'encart et non dans
  une variable de ce script : le thème re-rend la fiche par morph au changement
  de variante, et un état gardé en mémoire seule serait perdu sans que rien ne
  le montre à l'écran.

  ⚠️ ON INTERCEPTE LE CLIC DU BOUTON D'AJOUT, PAS LE `submit` DU FORMULAIRE.

  Première version : un écouteur sur `submit`. Il marchait une fois sur deux, et
  la raison est nette : le bouton d'ajout porte `on:click="/handleClick"` et le
  thème appelle preventDefault() sur ce clic, ce qui ANNULE la soumission
  implicite du formulaire. Aucun `submit` n'est émis. Vérifié en écoutant
  `submit` sur document en capture : rien n'y passe. Le clic, lui, part toujours.

  ⚠️ ET ON AJOUTE LE CADEAU AVANT LE SAC, PAS APRÈS.

  Le cadeau n'est gratuit que parce qu'une remise automatique Shopify remet
  100 % sur une boucle DÈS QU'UN SAC EST AU PANIER. La remise est recalculée à
  chaque lecture du panier : l'ordre ne change rien au montant final, mais tout
  à ce que le client VOIT. Boucle d'abord, elle apparaît une fraction de seconde
  à 76 € toute seule ; sac d'abord, le tiroir s'ouvre sur le sac puis se re-rend
  une seconde plus tard avec une ligne de plus, et on dirait un bogue.
  En l'ajoutant pendant que rien n'est affiché, le tiroir s'ouvre UNE fois, sur
  l'état final. On rejoue ensuite le clic marqué pour rendre la main au thème,
  qui ajoute le sac, joue son animation et ouvre le tiroir comme d'habitude.
*/
(function () {
  function encart() {
    return document.querySelector('[data-isli-gift]');
  }

  function choisi() {
    var bloc = encart();
    if (!bloc) return null;
    var champ = bloc.querySelector('[data-isli-gift-value]');
    if (!champ || !champ.value) return null;
    return { id: champ.value };
  }

  /* ══════════════ TANT QU'AUCUNE PAIRE N'EST CHOISIE, L'AJOUT EST FERMÉ ══════
     Le champ caché part vide (voir blocks/isli-bag-gift.liquid). Tant qu'il
     l'est, sur une fiche de sac éligible :

       - le bouton d'ajout porte le libellé d'invitation, sur SES DEUX FACES,
         faute de quoi l'ancien mot réapparaîtrait au survol ;
       - le clic n'ajoute rien : il ouvre le tiroir des paires.

     ⚠️ LE BOUTON N'EST PAS `disabled`, ET C'EST VOLONTAIRE. Un bouton éteint ne
     dit pas quoi faire et n'accepte pas le clic : le client tape dessus deux
     fois et s'arrête là. Celui-ci reste vivant et mène exactement là où il faut.
     L'ajout est refusé quand même, ce qui était la demande.

     ⚠️ LE VRAI LIBELLÉ D'ACHAT N'EST PAS ÉCRIT EN DUR. On retient celui qu'on
     lit tant qu'il n'est pas le nôtre : il vient du thème, il est traduit avec
     lui, et il survit aux re-rendus par morph, qui le réécrivent. */

  var libelleAchat = '';

  function boutons() {
    /* Les deux boutons d'ajout de la fiche : celui de la colonne et celui de la
       barre collante, qui pilote le premier par un clic simulé. */
    return document.querySelectorAll('.product-details .add-to-cart-button, [data-isli-stickybuy-add]');
  }

  function ouvrirChoix() {
    var bloc = encart();
    var ouvreur = bloc ? bloc.querySelector('[data-isli-gift-open]') : null;
    if (ouvreur) ouvreur.click();
  }

  function majBouton() {
    var bloc = encart();
    if (!bloc) return;

    var manque = !choisi();
    var invitation = bloc.getAttribute('data-isli-gift-cta') || 'Choose your earring';
    var liste = boutons();

    for (var b = 0; b < liste.length; b++) {
      var faces = liste[b].querySelectorAll('.isli-atc__face');
      if (!faces.length) continue;

      var courant = faces[faces.length - 1].textContent.trim();
      if (courant && courant !== invitation) libelleAchat = courant;

      var libelle = manque ? invitation : libelleAchat;
      if (!libelle) continue;

      /* On n'écrit que si le mot change : l'observateur ci-dessous nous
         entendrait sinon nous-mêmes, indéfiniment. */
      for (var f = 0; f < faces.length; f++) {
        if (faces[f].textContent !== libelle) faces[f].textContent = libelle;
      }

      liste[b].setAttribute('data-isli-gift-missing', manque ? 'true' : 'false');
    }
  }

  /* --- choix dans le tiroir --- */

  document.addEventListener('click', function (event) {
    var ligne = event.target && event.target.closest ? event.target.closest('[data-isli-gift-pick]') : null;
    if (!ligne) return;

    var bloc = encart();
    if (!bloc) return;

    var liste = ligne.closest('.isli-gift-list');
    if (liste) {
      var toutes = liste.querySelectorAll('[data-isli-gift-pick]');
      for (var i = 0; i < toutes.length; i++) toutes[i].setAttribute('aria-pressed', 'false');
    }
    ligne.setAttribute('aria-pressed', 'true');

    var champ = bloc.querySelector('[data-isli-gift-value]');
    if (champ) champ.value = ligne.getAttribute('data-isli-gift-pick');

    var nom = bloc.querySelector('[data-isli-gift-name]');
    if (nom) nom.textContent = ligne.getAttribute('data-gift-title');

    var barre = bloc.querySelector('[data-isli-gift-was]');
    if (barre) barre.textContent = ligne.getAttribute('data-gift-price');

    /* La vignette de l'encart suit le choix. On recopie la source de la ligne
       cliquée plutôt que de reconstruire une URL : le thème a déjà écrit la
       bonne taille et le bon format. */
    var vignetteSource = ligne.querySelector('img');
    var vignetteCible = bloc.querySelector('.isli-bundle__row--gift img');
    if (vignetteSource && vignetteCible) {
      vignetteCible.src = vignetteSource.currentSrc || vignetteSource.src;
      vignetteCible.srcset = vignetteSource.srcset || '';
    }

    majBouton();

    var dialogue = ligne.closest('dialog.isli-drawer');
    if (dialogue && typeof window.isliCloseDrawer === 'function') {
      window.isliCloseDrawer(dialogue);
    } else if (dialogue && dialogue.open) {
      dialogue.close();
    }
  });

  /* Le libellé est posé au chargement, puis reposé après chaque re-rendu de la
     colonne d'achat : le thème la morphe au changement de variante et à la mise
     à jour du panier, ce qui remet le libellé du thème. Un seul observateur,
     drapeau porté par le noeud, comme ailleurs dans ce fichier. */
  function surveiller() {
    var zone = document.querySelector('.product-details');
    if (!zone || zone.__isliGiftWatched) return;
    zone.__isliGiftWatched = true;
    new MutationObserver(majBouton).observe(zone, { childList: true, subtree: true });
  }

  function demarrer() {
    majBouton();
    surveiller();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
  document.addEventListener('shopify:section:load', demarrer);

  /* --- ajout au panier --- */

  document.addEventListener(
    'click',
    function (event) {
      var bouton = event.target && event.target.closest ? event.target.closest('.add-to-cart-button') : null;
      if (!bouton) return;

      /* Deuxième passage : c'est notre propre clic rejoué, on laisse filer. */
      if (bouton.__isliGiftDone) {
        bouton.__isliGiftDone = false;
        return;
      }

      var cadeau = choisi();

      /* ⚠️ AUCUNE PAIRE CHOISIE : ON N'AJOUTE PAS, ON FAIT CHOISIR.
         Le test porte sur la PRÉSENCE de l'encart : hors fiche de sac éligible
         il n'y a pas de cadeau à choisir et l'ajout doit filer normalement. */
      if (!cadeau) {
        if (!encart()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        ouvrirChoix();
        return;
      }

      var form = bouton.closest('form');
      if (!form) return;

      /* ⚠️ VERROU. Deux clics rapprochés partaient chacun avec son cadeau : le
         second arrivait avant que le premier n'ait répondu, et le panier
         repartait avec deux boucles. */
      if (bouton.__isliGiftBusy) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      bouton.__isliGiftBusy = true;

      event.preventDefault();
      event.stopImmediatePropagation();

      var rejouer = function () {
        bouton.__isliGiftBusy = false;
        bouton.__isliGiftDone = true;
        bouton.click();
      };

      /* ⚠️ UN SEUL CADEAU PAR PANIER, JAMAIS DEUX.
         La remise « Free earrings with your bag » porte `usesPerOrderLimit: 1` :
         la deuxième boucle ne peut PAS être gratuite. Or le script en ajoutait
         une à CHAQUE clic. Mesuré en ligne le 2026-07-26, panier vidé puis deux
         clics sur ADD TO CART d'un sac : total 326 € au lieu de 250, avec une
         ligne « Atlas Blue » à 76 € payée plein tarif à côté de celle à 0. Le
         sac, lui, n'était pas ajouté deux fois, un seul exemplaire étant en
         stock, et le thème affichait « The maximum quantity of this item is
         already in your cart » : le client lisait que rien n'avait été ajouté
         pendant qu'on lui facturait une paire.

         La ligne du cadeau est donc marquée d'une propriété, et on lit le
         panier avant d'ajouter. Le souligné initial de `_isli_gift` n'est pas
         décoratif : Shopify masque au client les propriétés qui commencent par
         lui. */
      var ajouterCadeau = function () {
        return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) {
            return r.json();
          })
          .then(function (panier) {
            var lignes = (panier && panier.items) || [];
            for (var i = 0; i < lignes.length; i++) {
              var props = lignes[i].properties;
              if (props && props._isli_gift) return null;
            }

            return fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [{ id: cadeau.id, quantity: 1, properties: { _isli_gift: '1' } }]
              })
            }).then(function (reponse) {
              return reponse.json().then(function (data) {
                if (!reponse.ok) throw new Error(data.description || data.message || 'cart/add');
                return data;
              });
            });
          });
      };

      /* ⚠️ SI LE SAC N'ENTRE PAS, LE CADEAU NE DOIT PAS RESTER SEUL.
         Le cadeau part AVANT le sac, pour que le tiroir s'ouvre une seule fois
         sur l'état final. Mais quand le sac est refusé, et il l'est dès le
         deuxième clic puisque les sacs vendables n'ont qu'un exemplaire, la
         boucle restait au panier, seule, à 76 € plein tarif : la remise a
         besoin d'un sac pour s'appliquer.

         On contrôle donc après coup, et on retire la ligne si le sac n'est
         jamais arrivé. Quatre tentatives espacées plutôt qu'un seul contrôle :
         l'ajout du thème est asynchrone et un réseau lent ferait conclure trop
         tôt à l'échec. On ne retire QUE la ligne marquée, jamais une boucle que
         le client aurait mise au panier lui-même. */
      var verifierSac = function () {
        var champ = form.querySelector('[name="id"]');
        var idSac = champ ? String(champ.value) : '';
        if (!idSac) return;

        var essais = 0;

        var controler = function () {
          fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) {
              return r.json();
            })
            .then(function (panier) {
              var lignes = (panier && panier.items) || [];
              var sac = null;
              var cadeauLigne = null;

              for (var i = 0; i < lignes.length; i++) {
                if (String(lignes[i].variant_id) === idSac) sac = lignes[i];
                if (lignes[i].properties && lignes[i].properties._isli_gift) cadeauLigne = lignes[i];
              }

              if (sac || !cadeauLigne) return;

              if (essais < 4) {
                essais += 1;
                setTimeout(controler, 700);
                return;
              }

              fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: cadeauLigne.key, quantity: 0 })
              });
            })
            .catch(function () {});
        };

        setTimeout(controler, 900);
      };

      ajouterCadeau()
        .then(function () {
          rejouer();
          verifierSac();
        })
        .catch(function (erreur) {
          bouton.__isliGiftBusy = false;
          /* ⚠️ LE SAC PASSE QUAND MÊME. Le cadeau est un supplément : le rater
             ne doit pas empêcher la vente. On le dit, dans le créneau d'erreur
             du thème déjà habillé ISLI. */
          var creneau = form.querySelector('.product-form-text__error');

          if (creneau) {
            var ancien = creneau.querySelector('[data-isli-gift-error]');
            if (ancien) ancien.remove();
            var enveloppe = document.createElement('span');
            enveloppe.setAttribute('data-isli-gift-error', '');
            enveloppe.textContent = (ISLI_TEXTES.cadeau_echec || 'Your free earrings could not be added.') + ' ' + (erreur.message || '');
            creneau.classList.remove('hidden');
            creneau.appendChild(enveloppe);
          }

          rejouer();
        });
    },
    true
  );

  /* ⚠️ LE CLAVIER NE DOIT PAS PASSER À CÔTÉ DU BLOCAGE.
     Le bouton est un `submit` : une entrée validée depuis un champ du formulaire
     l'envoie sans qu'aucun clic ne parte, et le garde ci-dessus serait muet. On
     ferme donc aussi l'envoi du formulaire lui-même. */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      if (!encart() || choisi()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      ouvrirChoix();
    },
    true
  );
})();

/*
  ISLI STUDIO — nettoyage des vols vers le panier.

  Le thème fait voler une vignette du bouton d'ajout jusqu'à l'icône du panier.
  Erevan n'en veut nulle part : isli-lv.css met <fly-to-cart> en display: none.

  ⚠️ MAIS C'EST LE THÈME QUI RETIRE CET ÉLÉMENT, ET IL NE PEUT PLUS LE FAIRE.
  assets/fly-to-cart.js attend `Promise.allSettled(this.getAnimations()...)`
  avant d'appeler remove(). En display: none aucune animation ne tourne, la
  liste est vide, et surtout le script n'y arrive même pas : il passe d'abord
  par `yieldToMainThread()` (assets/utilities.js ligne 14), qui retombe sur
  requestAnimationFrame quand `scheduler.yield` n'existe pas. Sans retrait, un
  nœud s'accumulerait sur le body à CHAQUE ajout au panier.

  On le retire donc nous-mêmes, sans rien attendre. Économie au passage : trois
  animations de 600ms en moins par ajout, pour un élément que personne ne voit.
*/
(function () {
  function nettoyer(noeuds) {
    for (var i = 0; i < noeuds.length; i++) {
      var n = noeuds[i];
      if (n.nodeType === 1 && n.tagName === 'FLY-TO-CART') n.remove();
    }
  }

  /* Observation limitée aux enfants DIRECTS du body : les deux scripts du thème
     y posent l'élément par appendChild (product-form.js ligne 113 et
     sticky-add-to-cart.js ligne 189). Pas de subtree, inutile de se réveiller
     pour chaque mutation du site. */
  function armer() {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) nettoyer(mutations[i].addedNodes);
    }).observe(document.body, { childList: true });

    /* Et un passage initial, pour le cas où un nœud aurait été posé avant que
       ce module ne tourne. */
    nettoyer(document.querySelectorAll('fly-to-cart'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armer);
  } else {
    armer();
  }
})();

/*
  ISLI STUDIO — voile derrière le tiroir panier ouvert en non modal.

  ⚠️ POURQUOI CE MODULE EXISTE. Au-dessus de 990px le thème ouvre le tiroir avec
  `panel.show()` (assets/theme-drawer.js ligne 222), donc en NON MODAL. Un
  dialogue non modal n'a PAS de ::backdrop : il n'y a rien à styler, et c'est
  déjà la raison pour laquelle la fermeture au clic extérieur a dû être écrite à
  la main. On pose donc un voile nous-mêmes, avec exactement le même dessin, tenu
  en variables dans isli-lv.css.

  En dessous de 990px le tiroir est modal, son ::backdrop natif existe et il est
  habillé en CSS : ce module ne fait alors rien.
*/
(function () {
  var CLASSE = 'isli-scrim';

  function tiroirPanier() {
    return document.querySelector('theme-drawer#cart-drawer');
  }

  function retirer() {
    var voile = document.querySelector('.' + CLASSE);
    if (!voile) return;

    voile.removeAttribute('data-shown');

    /* On attend la fin du fondu avant de retirer le nœud, sinon le voile
       disparaît d'un coup alors que le tiroir glisse encore. Le minuteur est un
       filet : `transitionend` ne part pas si l'onglet est en arrière-plan. */
    var fini = false;
    var finir = function () {
      if (fini) return;
      fini = true;
      if (voile.parentNode) voile.parentNode.removeChild(voile);
    };

    voile.addEventListener('transitionend', finir);
    setTimeout(finir, 600);
  }

  function poser() {
    var tiroir = tiroirPanier();
    if (!tiroir) return;

    var panneau = tiroir.querySelector('dialog');
    if (!panneau) return;

    /* Modal : le ::backdrop natif fait le travail, on ne double pas. */
    if (panneau.matches(':modal')) return;
    if (document.querySelector('.' + CLASSE)) return;

    var voile = document.createElement('div');
    voile.className = CLASSE;
    document.body.appendChild(voile);

    /* ⚠️ PAS DE requestAnimationFrame ICI. Il faut bien laisser le navigateur
       calculer le style initial avant de poser l'état visible, sinon insertion
       et changement d'opacité sont composés ensemble et le fondu ne joue pas.
       Mais rAF est SUSPENDU dans un onglet en arrière-plan : le voile restait
       alors à opacité nulle, posé et invisible, derrière un tiroir bien ouvert.
       Une lecture de mise en page force le même calcul, sans dépendre d'aucune
       horloge. */
    void voile.offsetHeight;
    voile.setAttribute('data-shown', '');
  }

  document.addEventListener('theme-drawer:open', function (event) {
    if (event.target && event.target.id === 'cart-drawer') poser();
  });

  document.addEventListener('theme-drawer:close', function (event) {
    if (event.target && event.target.id === 'cart-drawer') retirer();
  });

  /* Le seuil modal du thème est à 990px : en franchissant la largeur tiroir
     ouvert, on passe d'un mode à l'autre et le voile doit suivre. */
  var reprise;
  window.addEventListener('resize', function () {
    clearTimeout(reprise);
    reprise = setTimeout(function () {
      var tiroir = tiroirPanier();
      if (tiroir && tiroir.hasAttribute('open')) poser();
      else retirer();
    }, 150);
  });
})();


/*
  ISLI STUDIO — la barre d'achat collante des fiches produit.

  Voir blocks/isli-sticky-buy.liquid pour le POURQUOI on n'emploie pas la barre
  native du thème. Ici, seulement le comment.

  ⚠️ L'ANCRE N'EST PAS LA MÊME SUR TOUTES LES FICHES.
  Le thème observe `.buy-buttons-block` en dur. Sur les 45 fiches de boucles ce
  bloc est en `display: none` (isli-lv.css, chapitre du renvoi au composeur) :
  sa boîte mesure zéro et aucun seuil n'est jamais franchi. On cherche donc
  l'action RÉELLEMENT VISIBLE de la colonne, le renvoi d'abord, l'achat ensuite,
  en testant `offsetParent` qui vaut null dès qu'un ancêtre est masqué.

  ⚠️ LE SEUIL EST `bottom <= 0`, PAS `bottom < 0 || top < 0`.
  Le thème sort sa barre dès que le HAUT du bloc d'achat passe le pli
  (sticky-add-to-cart.js ligne 130), donc alors que le bouton est encore à
  l'écran : on voit deux boutons d'ajout en même temps. Ici la barre sort quand
  le bloc a FINI de sortir par le haut, ce qui est exactement la demande.

  ⚠️ AUCUN OBSERVATEUR SUR LE PIED DE PAGE, ET C'EST UNE CORRECTION.
  Le thème efface sa barre dès que le pied entre dans la vue, 200px d'avance
  comprises. Mesuré sur une fiche de sac : le bas du bloc d'achat est à 635px,
  le haut du pied à 1453 pour une fenêtre de 900. Le pied entre donc dans la
  vue à 553px de défilement, AVANT que le bloc d'achat n'en sorte à 635. La
  fenêtre où la barre pouvait apparaître était vide : elle ne serait jamais
  sortie, sur aucune fiche. Les colonnes de cette fiche faisant exactement une
  hauteur d'écran, la page entière ne défile que de 918px.

  On ne masque donc rien, et on réserve la place autrement : la dernière
  section du pied porte une réserve de la hauteur de la barre (isli-lv.css,
  chapitre BARRE D'ACHAT COLLANTE), qui garantit qu'aucun contenu ne finit
  caché derrière elle. Réserve statique, donc aucun saut de mise en page.

  ⚠️ L'AJOUT PILOTE LE VRAI BOUTON, IL N'APPELLE PAS /cart/add.
  Le module du cadeau intercepte le clic en capture et exige un formulaire ; un
  ajout direct depuis cette barre ferait perdre la boucle offerte sans rien
  dire. On repose le drapeau `puppet` du thème avant le clic, comme le fait sa
  propre barre (sticky-add-to-cart.js ligne 178), ce qui évite au bouton
  principal, hors écran, de jouer son état « ajouté » pour personne.

  Aucun requestAnimationFrame : la bascule est portée par deux
  IntersectionObserver et un attribut, l'animation est en CSS.
*/
(function () {
  var ANCRES = ['.product-details .isli-pack-cta', '.product-details .buy-buttons-block'];

  var barre = null;
  var observateurAncre = null;

  function ancre() {
    for (var i = 0; i < ANCRES.length; i++) {
      var element = document.querySelector(ANCRES[i]);
      /* offsetParent vaut null dès qu'un ancêtre est en display:none. C'est le
         test le moins cher, et le seul qui distingue les deux familles de
         fiches sans lire aucune classe de produit. */
      if (element && element.offsetParent !== null) return element;
    }
    return null;
  }

  function montrer() {
    if (!barre) return;
    barre.setAttribute('data-stuck', 'true');
  }

  function cacher() {
    if (barre) barre.setAttribute('data-stuck', 'false');
  }

  function armer() {
    if (observateurAncre) observateurAncre.disconnect();
    observateurAncre = null;

    barre = document.querySelector('[data-isli-stickybuy]');
    if (!barre) return;

    var cible = ancre();
    if (!cible) return;

    observateurAncre = new IntersectionObserver(function (entrees) {
      var entree = entrees[entrees.length - 1];
      if (!entree) return;

      if (entree.isIntersecting) {
        cacher();
        return;
      }

      /* Sorti par le HAUT : on montre. Sorti par le bas, c'est-à-dire pas
         encore atteint, on ne montre rien. */
      if (entree.boundingClientRect.bottom <= 0) montrer();
      else cacher();
    });
    observateurAncre.observe(cible);
  }

  document.addEventListener('click', function (event) {
    var bouton = event.target && event.target.closest ? event.target.closest('[data-isli-stickybuy-add]') : null;
    if (!bouton) return;

    var vrai = document.querySelector('.product-details .buy-buttons-block .add-to-cart-button');
    if (!vrai) return;

    vrai.setAttribute('data-puppet', 'true');
    vrai.click();

    /* Le thème repose son drapeau à la fin de la promesse d'ajout. On ne
       s'accroche pas à cet événement pour si peu : un minuteur franc suffit, et
       il ne dépend d'aucune horloge d'animation. */
    setTimeout(function () {
      vrai.setAttribute('data-puppet', 'false');
    }, 1200);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armer);
  } else {
    armer();
  }

  document.addEventListener('shopify:section:load', armer);
})();

/*
  ISLI STUDIO — ON NE CHARGE QUE LA VIDÉO QUE L'ON VOIT.

  ⚠️ LE CHIFFRE QUI JUSTIFIE CE MODULE. Relevé sur l'accueil en 375px de large,
  page complète : 9,6 Mo transférés, dont 7,3 Mo de vidéo. Le thème rend LES
  DEUX bannières, celle d'ordinateur et celle de téléphone, et n'en masque
  qu'une en CSS. Or `display: none` n'empêche pas le chargement : les deux
  fichiers arrivaient entiers (readyState 4), soit 3 Mo téléchargés pour une
  vidéo de 0×0 pixel. Sur ordinateur, la perte est de 4,3 Mo, dans l'autre sens.

  Ce module pose le `src` sur la SEULE vidéo réellement affichée, et le repose
  si la largeur change de bord (rotation d'un téléphone, fenêtre redimensionnée).
  La vidéo cachée n'a jamais d'adresse, donc ne charge rien.

  ⚠️ ET IL FAUT RELANCER LA LECTURE À LA MAIN. Un <video autoplay> sans `src`
  au chargement ne démarre pas tout seul quand on lui en donne un : l'attribut
  n'est lu qu'au parsing. D'où le `play()`, dont l'échec est ignoré, les
  navigateurs pouvant refuser une lecture automatique.
*/
(function () {
  function visible(element) {
    /* offsetParent tombe à null dès qu'un ancêtre est en display:none, ce qui
       est exactement la façon dont le thème masque la vidéo du mauvais format. */
    return element.offsetParent !== null || element.getClientRects().length > 0;
  }

  function poser() {
    var videos = document.querySelectorAll('video[data-isli-video]');
    for (var i = 0; i < videos.length; i++) {
      var v = videos[i];
      var url = v.getAttribute('data-isli-video');
      if (!url) continue;

      if (visible(v)) {
        /* L'affiche gardée en réserve n'est posée qu'au moment où ce format
           devient celui de l'écran : elle ne pèse rien tant qu'on ne la voit
           pas. */
        var affiche = v.getAttribute('data-isli-poster');
        if (affiche && !v.getAttribute('poster')) v.setAttribute('poster', affiche);

        if (v.getAttribute('src') === url) continue;
        v.setAttribute('src', url);
        v.load();
        var lecture = v.play();
        if (lecture && typeof lecture.catch === 'function') lecture.catch(function () {});
      } else if (v.hasAttribute('src')) {
        /* Le format a changé de bord : on rend la mémoire et la bande passante
           plutôt que de garder deux vidéos décodées. */
        v.pause();
        v.removeAttribute('src');
        v.load();
      }
    }
  }

  var minuteur = null;
  function replanifier() {
    if (minuteur) clearTimeout(minuteur);
    minuteur = setTimeout(poser, 200);
  }

  /* ⚠️ ON ATTEND QUE LA PAGE SOIT PEINTE AVANT DE DEMANDER LA VIDÉO.
     Elle pèse 4,3 Mo sur téléphone : lancée au parsing, elle se dispute la
     bande passante avec le CSS, les polices et la première image, c'est à dire
     avec tout ce qui décide du moment où la page devient lisible. L'affiche
     (`poster`), elle, est dans le HTML d'origine et peint la première image
     tout de suite : le visiteur voit donc la bannière sans attendre, et le film
     démarre un battement plus tard, sur la même image.

     `load` plutôt qu'un délai en dur : on part quand le navigateur a fini, pas
     après une durée devinée. Le repli couvre le cas où l'événement est déjà
     passé, par exemple à la navigation par transition de vue. */
  /* ⚠️ PAS DE requestAnimationFrame ICI. Un onglet en arrière-plan ne peint
     pas, donc n'appelle jamais le rappel : la vidéo n'était jamais demandée.
     Constaté à la mesure, aucune requête de film après l'événement `load`. Un
     `setTimeout` à zéro rend la main au navigateur de la même façon et part,
     lui, même sans peinture. */
  function demarrer() {
    setTimeout(poser, 0);
  }

  if (document.readyState === 'complete') {
    demarrer();
  } else {
    window.addEventListener('load', demarrer, { once: true });
  }
  window.addEventListener('resize', replanifier);
  document.addEventListener('shopify:section:load', poser);

  /* ⚠️ ET ON REDEMANDE LA LECTURE AU RETOUR SUR L'ONGLET. Une page ouverte en
     arrière-plan peut se voir refuser la lecture automatique : la bannière
     resterait alors figée sur son affiche une fois l'onglet revenu au premier
     plan. Mesuré dans le panneau caché : `paused: true` juste après la pose du
     `src`, puis lecture normale dès qu'on la redemande. */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    var videos = document.querySelectorAll('video[data-isli-video][src]');
    for (var i = 0; i < videos.length; i++) {
      if (!videos[i].paused) continue;
      var lecture = videos[i].play();
      if (lecture && typeof lecture.catch === 'function') lecture.catch(function () {});
    }
  });
})();

/*
  ISLI STUDIO — LES DIAPOSITIVES CACHÉES NE DOIVENT PAS ÊTRE ATTEIGNABLES AU
  CLAVIER.

  ⚠️ CE QUE DIT L'AUDIT. PageSpeed, volet accessibilité : « les éléments
  [aria-hidden="true"] contiennent des descendants sélectionnables », relevé sur
  toutes les diapositives hors écran des deux carrousels de l'accueil, soit
  vingt-deux cartes. Chacune porte deux liens et un bouton d'ajout.

  ⚠️ POURQUOI C'EST UN VRAI DÉFAUT ET PAS UN DÉTAIL D'OUTIL. `aria-hidden` retire
  l'élément de l'arbre d'accessibilité mais PAS du parcours de tabulation : un
  lecteur d'écran annonce alors « lien » sans pouvoir dire lequel, et la personne
  tabule dans le vide sur vingt-deux cartes invisibles. C'est aussi ce qui fait
  échouer l'audit de navigation agentique.

  Le thème pose `aria-hidden` d'après un observateur de visibilité
  (assets/slideshow.js, #updateVisibleSlides) : ce module ne fait que SUIVRE cet
  attribut et retirer, ou rendre, la tabulation en conséquence.

  ⚠️ ON NE MET PAS `inert`, ET C'EST DÉLIBÉRÉ. `inert` coupe aussi le pointeur :
  une carte à moitié sortie du rail, que l'observateur compte comme cachée,
  cesserait d'être cliquable à la souris. `tabindex="-1"` ne touche qu'au
  clavier, ce qui est exactement le comportement attendu d'un carrousel.
*/
(function () {
  var FOCUSABLES = 'a[href], button, input, select, textarea, [tabindex]';
  var MARQUE = 'data-isli-tab';

  function appliquer(diapo) {
    var cachee = diapo.getAttribute('aria-hidden') === 'true';
    var cibles = diapo.querySelectorAll(FOCUSABLES);

    for (var i = 0; i < cibles.length; i++) {
      var el = cibles[i];

      if (cachee) {
        if (el.hasAttribute(MARQUE)) continue;
        /* On garde la valeur d'origine : certains éléments portent déjà un
           tabindex, il faut pouvoir le rendre tel quel. */
        el.setAttribute(MARQUE, el.getAttribute('tabindex') === null ? '' : el.getAttribute('tabindex'));
        el.setAttribute('tabindex', '-1');
      } else if (el.hasAttribute(MARQUE)) {
        var ancien = el.getAttribute(MARQUE);
        if (ancien === '') {
          el.removeAttribute('tabindex');
        } else {
          el.setAttribute('tabindex', ancien);
        }
        el.removeAttribute(MARQUE);
      }
    }
  }

  function balayer(racine) {
    var diapos = (racine || document).querySelectorAll('slideshow-slide[aria-hidden]');
    for (var i = 0; i < diapos.length; i++) appliquer(diapos[i]);
  }

  function armer() {
    balayer(document);

    /* Deux choses à surveiller : l'attribut lui-même, que le thème retourne au
       défilement du rail, et l'arrivée de nouvelles diapositives, les sections
       étant re-rendues par morph. */
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes' && m.target.tagName === 'SLIDESHOW-SLIDE') {
          appliquer(m.target);
        } else if (m.type === 'childList' && m.addedNodes.length) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (n.nodeType !== 1) continue;
            if (n.tagName === 'SLIDESHOW-SLIDE') appliquer(n);
            else balayer(n);
          }
        }
      }
    }).observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-hidden'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armer);
  } else {
    armer();
  }
})();

/*
  ISLI STUDIO — LOCALISATION EN TIROIR (snippets/isli-localisation.liquid).

  Trois gestes, rien d'autre :
    a) « Modifier » déplie ou replie la liste des pays, et pose le focus dans
       la recherche à l'ouverture ;
    b) taper filtre la liste, sans tenir compte des accents ni de la casse :
       « reunion » doit trouver « La Réunion » ;
    c) cliquer un pays remplit le champ caché, réécrit l'encadré, referme la
       liste. RIEN N'EST SOUMIS : c'est le bouton « Continuer », un vrai
       bouton de soumission, qui envoie pays et langue d'un seul coup. C'est
       toute la différence avec le composant du thème, qui rechargeait la
       page à chaque geste.

  Les langues sont de vraies cases radio nommées language_code : le navigateur
  gère seul la sélection, le clavier et l'envoi, aucun script à écrire.

  Délégué au document : le tiroir vit dans l'entête, que le thème re-rend par
  morphing ; des écouteurs posés sur les noeuds partiraient avec eux.
*/
(function () {
  function sansAccents(chaine) {
    return chaine.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }

  function basculerListe(bouton, ouvrir) {
    var liste = document.getElementById('isli-loc-liste');
    if (!liste) return;

    if (ouvrir) {
      liste.removeAttribute('hidden');
      var champ = liste.querySelector('[data-isli-loc-recherche]');
      if (champ) champ.focus();
    } else {
      liste.setAttribute('hidden', '');
    }
    if (bouton) bouton.setAttribute('aria-expanded', ouvrir ? 'true' : 'false');
  }

  document.addEventListener('click', function (event) {
    var cible = event.target;
    if (!cible || !cible.closest) return;

    var modifier = cible.closest('[data-isli-loc-modifier]');
    if (modifier) {
      var liste = document.getElementById('isli-loc-liste');
      if (liste) basculerListe(modifier, liste.hasAttribute('hidden'));
      return;
    }

    var ligne = cible.closest('[data-isli-loc-pays]');
    if (ligne) {
      var racine = ligne.closest('.isli-localisation');
      if (!racine) return;

      var champ = racine.querySelector('[data-isli-loc-champ]');
      var nom = racine.querySelector('[data-isli-loc-nom]');
      if (champ) champ.value = ligne.getAttribute('data-isli-loc-pays');
      if (nom) nom.textContent = ligne.getAttribute('data-nom');

      var lignes = racine.querySelectorAll('[data-isli-loc-pays]');
      for (var i = 0; i < lignes.length; i++) lignes[i].setAttribute('aria-selected', 'false');
      ligne.setAttribute('aria-selected', 'true');

      basculerListe(racine.querySelector('[data-isli-loc-modifier]'), false);
    }
  });

  document.addEventListener('input', function (event) {
    var champ = event.target;
    if (!champ || !champ.matches || !champ.matches('[data-isli-loc-recherche]')) return;

    var conteneur = champ.closest('.isli-localisation__picker');
    if (!conteneur) return;

    var terme = sansAccents(champ.value.trim());
    var elements = conteneur.querySelectorAll('.isli-localisation__country-item');
    var visibles = 0;

    for (var i = 0; i < elements.length; i++) {
      var bouton = elements[i].querySelector('[data-nom]');
      var nom = bouton ? sansAccents(bouton.getAttribute('data-nom') || '') : '';
      var montre = terme === '' || nom.indexOf(terme) !== -1;

      if (montre) {
        elements[i].removeAttribute('hidden');
        visibles++;
      } else {
        elements[i].setAttribute('hidden', '');
      }
    }

    var vide = conteneur.querySelector('[data-isli-loc-vide]');
    if (vide) {
      if (visibles === 0) vide.removeAttribute('hidden');
      else vide.setAttribute('hidden', '');
    }
  });
})();


/*
  ISLI STUDIO — composeur de charms (sections/isli-charm-builder.liquid).

  Trois responsabilités, et rien d'autre :
    1. retenir quel charm occupe quel emplacement ;
    2. tenir le récapitulatif à jour, remise comprise ;
    3. poser les lignes au panier, la créole en propriété.

  LE TIROIR N'EST PAS GÉRÉ ICI. Il appartient au thème : `data-isli-drawer-open`
  sur le bouton d'un emplacement suffit à l'ouvrir, et pour le refermer on
  déclenche son propre bouton de fermeture. Reproduire l'ouverture ici aurait
  dupliqué l'animation, le piège de focus et la gestion du fond.

  LA REMISE EST CALCULÉE À TITRE D'AFFICHAGE, JAMAIS APPLIQUÉE. C'est Shopify
  qui la pose, en remise automatique sur la collection. Les deux calculs doivent
  s'accorder : on offre les pièces les MOINS CHÈRES de chaque groupe, ce qui est
  la règle de Shopify pour une remise « achetez X, obtenez Y ». Tous les charms
  étant au même prix aujourd'hui, la règle ne se voit pas ; elle comptera le jour
  où un charm sera tarifé autrement.
*/
(function () {
  var root = null;
  var moneyFormat = '{{amount}}';
  var slots = {};
  var emplacementActif = null;

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0];
    var decimals = parts[1];

    function group(sep) {
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    }

    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, name) {
      switch (name) {
        case 'amount_no_decimals':
          return group(',');
        case 'amount_with_comma_separator':
          return group('.') + ',' + decimals;
        case 'amount_no_decimals_with_comma_separator':
          return group('.');
        case 'amount_with_apostrophe_separator':
          return group("'") + '.' + decimals;
        default:
          return group(',') + '.' + decimals;
      }
    });
  }

  function nombre(attribut, defaut) {
    var v = parseInt(root.getAttribute(attribut), 10);
    return isNaN(v) ? defaut : v;
  }

  function choisis() {
    var liste = [];
    for (var k in slots) {
      if (slots[k]) liste.push(slots[k]);
    }
    return liste;
  }

  /* La remise : on groupe par (acheté + offert) et on offre, dans chaque groupe
     complet, les `offer_free` pièces les moins chères. */
  function remiseEnCentimes(pieces) {
    var acheter = nombre('data-offer-buy', 0);
    var offrir = nombre('data-offer-free', 0);
    if (acheter < 1 || offrir < 1) return 0;

    var groupe = acheter + offrir;
    var prix = pieces
      .map(function (p) {
        return p.price;
      })
      .sort(function (a, b) {
        return a - b;
      });

    var groupesComplets = Math.floor(prix.length / groupe);
    var total = 0;
    for (var i = 0; i < groupesComplets * offrir; i++) total += prix[i];
    return total;
  }

  function render() {
    if (!root) return;

    var pieces = choisis();
    var total = pieces.length;
    var nbSlots = nombre('data-slots', 3);
    var acheter = nombre('data-offer-buy', 0);
    var offrir = nombre('data-offer-free', 0);

    /* les emplacements */
    var cases = root.querySelectorAll('[data-isli-charms-slot]');
    for (var i = 0; i < cases.length; i++) {
      var index = cases[i].getAttribute('data-isli-charms-slot');
      var piece = slots[index];
      var bouton = cases[i].querySelector('[data-isli-charms-pick]');
      var retirer = cases[i].querySelector('[data-isli-charms-remove]');
      var image = bouton.querySelector('.isli-charms__slot-image');

      cases[i].classList.toggle('isli-charms__slot--filled', !!piece);

      if (piece) {
        if (!image) {
          image = document.createElement('img');
          image.className = 'isli-charms__slot-image';
          image.setAttribute('alt', '');
          image.setAttribute('loading', 'lazy');
          bouton.appendChild(image);
        }
        image.src = piece.image;
        if (retirer) retirer.hidden = false;
      } else {
        if (image) image.remove();
        if (retirer) retirer.hidden = true;
      }

      var intitule = cases[i].querySelector('[data-isli-charms-slot-label]');
      if (intitule) {
        intitule.textContent = piece
          ? piece.title
          : (root.getAttribute('data-empty-slot-label') || 'Choisir un charm') + ' ' + index;
      }
    }

    /* les vignettes déjà posées, signalées dans la grille */
    /* Le tiroir est un <dialog> : selon le contexte il est frere de la racine
       (page) ou dedans (bloc de fiche). On interroge donc le document. */
    var chips = document.querySelectorAll('[data-isli-charms-choose]');
    for (var c = 0; c < chips.length; c++) {
      var id = chips[c].getAttribute('data-isli-charms-choose');
      var pose = false;
      for (var s in slots) {
        if (slots[s] && String(slots[s].id) === String(id)) pose = true;
      }
      chips[c].classList.toggle('isli-charms__chip--used', pose);
    }

    /* le récapitulatif */
    var totaux = root.querySelector('[data-isli-charms-totals]');
    var sous = 0;
    for (var p = 0; p < pieces.length; p++) sous += pieces[p].price;
    var remise = remiseEnCentimes(pieces);

    if (totaux) {
      totaux.hidden = total === 0;
      var elSous = root.querySelector('[data-isli-charms-subtotal]');
      var elTotal = root.querySelector('[data-isli-charms-total]');
      var ligneRemise = root.querySelector('[data-isli-charms-saving-row]');
      var elRemise = root.querySelector('[data-isli-charms-saving]');
      if (elSous) elSous.textContent = formatMoney(sous);
      if (elTotal) elTotal.textContent = formatMoney(sous - remise);
      if (ligneRemise) ligneRemise.hidden = remise === 0;
      if (elRemise) elRemise.textContent = '−' + formatMoney(remise);
    }

    /* ⚠️ PLUS DE MESSAGE D'ACCOMPAGNEMENT SOUS LES CASES. (2026-08-08)
       Il disait « Votre piece offerte vous attend », « Encore une piece et la
       suivante est offerte ». Trois formulations pour une offre que la banniere
       annonce deja juste au-dessus des cases et que la pastille « Offert » de la
       troisieme confirme. Retire a la demande d'Erevan : redire la meme chose
       une troisieme fois n'aidait personne a decider.
       Le noeud reste absent du balisage, il n'y a donc rien a mettre a jour. */

    var ajouter = root.querySelector('[data-isli-charms-add]');
    if (ajouter) ajouter.disabled = total === 0;
  }

  function creoleChoisie() {
    var coche = root.querySelector('[data-isli-charms-creole]:checked');
    return coche ? coche.value : '';
  }

  function fermerTiroir() {
    var id = root.getAttribute('data-drawer');
    var dialog = id ? document.getElementById(id) : null;
    if (!dialog) return;
    var fermeture = dialog.querySelector('[data-isli-drawer-close]');
    if (fermeture) fermeture.click();
    else dialog.close();
  }

  function ajouterAuPanier(bouton) {
    var pieces = choisis();
    if (!pieces.length) return;

    var creole = creoleChoisie();
    var propriete = root.getAttribute('data-creole-label') || 'Créole';

    var items = pieces.map(function (p) {
      var ligne = { id: parseInt(p.id, 10), quantity: 1 };
      if (creole) {
        ligne.properties = {};
        ligne.properties[propriete] = creole;
      }
      return ligne;
    });

    /* ⚠️ LE LIBELLE VIT DANS LES DEUX FACES DE `isli-atc`, PAS DANS UN SEUL SPAN.
       Releve sur la fiche du Toubkal dans le navigateur : l'icone de panier et
       la coche du theme y sont MASQUEES par la feuille ISLI, et ce qui se voit
       est la bascule de texte maison, deux faces superposees qui roulent l'une
       sur l'autre. Ecrire dans une seule ferait apparaitre l'ancien texte au
       moment de la bascule. */
    var faces = bouton.querySelectorAll('.isli-atc__face');
    var avant = faces.length ? faces[0].textContent : '';
    function libelle(t) {
      for (var f = 0; f < faces.length; f++) faces[f].textContent = t;
    }

    bouton.disabled = true;
    libelle((typeof ISLI_TEXTES !== 'undefined' && ISLI_TEXTES.un_instant) || 'Un instant…');

    /* ⚠️ ON NE REDIRIGE PAS VERS LE PANIER, ON OUVRE LE TIROIR DU THÈME.
       Première version : faute d'avoir trouvé le tiroir, on envoyait la cliente
       sur /cart. C'était une sortie de page au moment précis où elle venait de
       composer, et une rupture avec tout le reste du site, où un ajout ouvre le
       tiroir sans quitter la page.

       Le tiroir est `theme-drawer#cart-drawer`, et le bouton du header porte
       `on:click="#cart-drawer/toggle"`. On demande donc à /cart/add.js de
       renvoyer la section déjà rendue, on la passe au thème par son propre
       événement `shopify:cart:lines-update` (ses modules lisent une propriété
       `promise` sur l'événement, pas `detail`), puis on déclenche le bouton du
       header. Le thème morphe et anime lui-même : rien n'est réimplémenté ici. */
    var SECTION_TIROIR = 'cart-drawer-section';

    fetch(isliChemin('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: SECTION_TIROIR })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        return fetch(isliChemin('/cart.js') + '?sections=' + SECTION_TIROIR, {
          headers: { Accept: 'application/json' }
        });
      })
      .then(function (r) {
        return r.json();
      })
      .then(function (panier) {
        /* On vide la composition : laisser les emplacements remplis après un
           ajout ferait croire que le panier contient deux fois la sélection. */
        slots = {};
        render();
        libelle(avant);
        bouton.disabled = false;

        var evenement = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
        evenement.promise = Promise.resolve({
          cart: { totalQuantity: panier.item_count },
          detail: { itemCount: panier.item_count, sections: panier.sections || {} }
        });
        document.dispatchEvent(evenement);

        var declencheur = document.querySelector('[data-testid="cart-drawer-trigger"]');
        if (declencheur) declencheur.click();
        else window.location.href = isliChemin('/cart');
      })
      .catch(function () {
        bouton.disabled = false;
        libelle(avant);
      });
  }

  function onClick(event) {
    if (!root) return;
    var target = event.target;
    if (!target || !target.closest) return;

    /* la vignette d'un charm, dans le tiroir */
    var chip = target.closest('[data-isli-charms-choose]');
    if (chip) {
      var index = emplacementActif;
      if (!index) {
        /* aucun emplacement ouvert : on remplit le premier libre */
        var cases = root.querySelectorAll('[data-isli-charms-slot]');
        for (var i = 0; i < cases.length; i++) {
          var k = cases[i].getAttribute('data-isli-charms-slot');
          if (!slots[k]) {
            index = k;
            break;
          }
        }
      }
      if (!index) return;

      slots[index] = {
        id: chip.getAttribute('data-isli-charms-choose'),
        title: chip.getAttribute('data-title') || '',
        image: chip.getAttribute('data-image') || '',
        price: parseInt(chip.getAttribute('data-price'), 10) || 0
      };
      emplacementActif = null;
      render();
      fermerTiroir();
      return;
    }

    if (!root.contains(target)) return;

    var retirer = target.closest('[data-isli-charms-remove]');
    if (retirer) {
      delete slots[retirer.getAttribute('data-isli-charms-remove')];
      render();
      return;
    }

    var pick = target.closest('[data-isli-charms-pick]');
    if (pick) {
      emplacementActif = pick.getAttribute('data-isli-charms-pick');
      return;
    }

    var ajouter = target.closest('[data-isli-charms-add]');
    if (ajouter) {
      ajouterAuPanier(ajouter);
    }
  }

  function onChange(event) {
    if (!root || !event.target.closest) return;
    if (event.target.closest('[data-isli-charms-creole]')) render();
  }

  /* Sur la fiche d'un charm, la piece regardee est deja posee dans le premier
     emplacement : la cliente a clique dessus, la remettre a choisir serait lui
     faire refaire un geste qu'elle vient de faire. Sur la page du composeur,
     ces attributs n'existent pas et les trois cases s'ouvrent vides. */
  function preselection() {
    var id = root.getAttribute('data-preselect');
    if (!id) return;
    slots['1'] = {
      id: id,
      title: root.getAttribute('data-preselect-title') || '',
      image: root.getAttribute('data-preselect-image') || '',
      price: parseInt(root.getAttribute('data-preselect-price'), 10) || 0
    };
  }

  function start() {
    root = document.querySelector('[data-isli-charms]');
    if (!root) return;
    moneyFormat = root.getAttribute('data-money-format') || '{{amount}}';
    slots = {};
    emplacementActif = null;
    preselection();
    render();
  }

  document.addEventListener('click', onClick);
  document.addEventListener('change', onChange);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();

/*
  ISLI STUDIO — chargement de la suite du catalogue de charms.

  Liquid s'arrête à cinquante produits par page, pagination comprise. Avec
  cinquante-deux charms, deux manqueraient au tiroir.

  ⚠️ PLUS AUCUN BOUTON. (2026-08-08) La suite se chargeait sur clic, ce qui
  demandait à la cliente de gérer une limite technique qui ne la concerne pas.
  Le serveur ne pose plus qu'un repère invisible en fin de liste, et ce module le
  suit tout seul, page après page, jusqu'à épuisement. La grille se complète sans
  que rien ne bouge sous les yeux : les vignettes ajoutées viennent après celles
  déjà affichées, jamais au-dessus.

  Le balisage vient de l'API de rendu de section, donc du thème lui-même : rien
  à tenir à jour ici le jour où la vignette changera.
*/
(function () {
  var enCours = false;

  function suivante(repere) {
    if (!repere || enCours) return;

    var section = repere.getAttribute('data-section');
    var page = repere.getAttribute('data-page');
    var liste = repere.parentNode;
    if (!section || !page || !liste) return;

    enCours = true;
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(section) + '&page=' + encodeURIComponent(page);

    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('section');
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nouvelles = doc.querySelectorAll('.isli-charms__catalog-item, .isli-charms__catalog-break');
        if (!nouvelles.length) throw new Error('vide');

        for (var i = 0; i < nouvelles.length; i++) {
          liste.insertBefore(document.importNode(nouvelles[i], true), repere);
        }

        /* Le repère de la page suivante, s'il y en a une : on reprend son
           numéro et on enchaîne. Sinon le repère disparaît, la liste est
           complète. */
        var suite = doc.querySelector('[data-isli-charms-more]');
        enCours = false;
        if (suite) {
          repere.setAttribute('data-page', suite.getAttribute('data-page'));
          suivante(repere);
        } else {
          repere.parentNode.removeChild(repere);
        }
      })
      .catch(function () {
        enCours = false;
      });
  }

  function demarrer() {
    var repere = document.querySelector('[data-isli-charms-more]');
    if (repere) suivante(repere);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
  document.addEventListener('shopify:section:load', demarrer);
})();
